/* tslint:disable */
/* eslint-disable */
/**
 *
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";
import type { RequestArgs } from "./base";
// @ts-expect-error
import { BASE_PATH, BaseAPI, operationServerMap } from "./base";
// Some imports not used depending on template conditions
// @ts-expect-error
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from "./common";
import type { Configuration } from "./configuration";

/**
 *
 * @export
 * @interface AbstractMessage
 */
export interface AbstractMessage {
  /**
   *
   * @type {number}
   * @memberof AbstractMessage
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof AbstractMessage
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof AbstractMessage
   */
  content?: string;
  /**
   *
   * @type {boolean}
   * @memberof AbstractMessage
   */
  anonymous?: boolean;
  /**
   *
   * @type {Array<CommunicationAttachment>}
   * @memberof AbstractMessage
   */
  attachments?: Array<CommunicationAttachment>;
  /**
   *
   * @type {string}
   * @memberof AbstractMessage
   */
  author?: string;
}
/**
 *
 * @export
 * @interface AcceptInvitationRequest
 */
export interface AcceptInvitationRequest {
  /**
   *
   * @type {string}
   * @memberof AcceptInvitationRequest
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof AcceptInvitationRequest
   */
  password?: string;
}
/**
 *
 * @export
 * @interface Account
 */
export interface Account {
  /**
   *
   * @type {number}
   * @memberof Account
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Account
   */
  emailAddress?: string;
  /**
   *
   * @type {Array<Role>}
   * @memberof Account
   */
  roles?: Array<Role>;
  /**
   *
   * @type {Person}
   * @memberof Account
   */
  person?: Person;
  /**
   *
   * @type {number}
   * @memberof Account
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof Account
   */
  lastLoginAt?: number;
  /**
   *
   * @type {NotificationSettings}
   * @memberof Account
   */
  notificationSettings?: NotificationSettings;
  /**
   *
   * @type {Array<number>}
   * @memberof Account
   */
  assignedEstateIds?: Array<number>;
}
/**
 *
 * @export
 * @interface AccountLevelConfig
 */
export interface AccountLevelConfig {
  /**
   *
   * @type {number}
   * @memberof AccountLevelConfig
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AccountLevelConfig
   */
  accountLevel?: AccountLevelConfigAccountLevelEnum;
  /**
   *
   * @type {number}
   * @memberof AccountLevelConfig
   */
  monthlyRate?: number;
  /**
   *
   * @type {boolean}
   * @memberof AccountLevelConfig
   */
  enabled?: boolean;
}

export const AccountLevelConfigAccountLevelEnum = {
  Basic: "BASIC",
  Start: "START",
  Plus: "PLUS",
  Pro: "PRO",
  Top: "TOP",
  Elite: "ELITE",
  Premium: "PREMIUM",
  Enterprise: "ENTERPRISE",
} as const;

export type AccountLevelConfigAccountLevelEnum =
  (typeof AccountLevelConfigAccountLevelEnum)[keyof typeof AccountLevelConfigAccountLevelEnum];

/**
 *
 * @export
 * @interface Address
 */
export interface Address {
  /**
   *
   * @type {string}
   * @memberof Address
   */
  street?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  city?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  postalCode?: string;
  /**
   *
   * @type {string}
   * @memberof Address
   */
  countryCode?: string;
}
/**
 *
 * @export
 * @interface Admin
 */
export interface Admin extends Role {}
/**
 *
 * @export
 * @interface Asset
 */
export interface Asset {
  /**
   *
   * @type {string}
   * @memberof Asset
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof Asset
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Asset
   */
  contentType?: AssetContentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof Asset
   */
  contentLength?: number;
  /**
   *
   * @type {number}
   * @memberof Asset
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof Asset
   */
  systemIdentifier?: string;
}

export const AssetContentTypeEnum = {
  Pdf: "PDF",
  Jpg: "JPG",
  Png: "PNG",
  Text: "TEXT",
} as const;

export type AssetContentTypeEnum =
  (typeof AssetContentTypeEnum)[keyof typeof AssetContentTypeEnum];

/**
 *
 * @export
 * @interface AttachmentUpdate
 */
export interface AttachmentUpdate {
  /**
   *
   * @type {number}
   * @memberof AttachmentUpdate
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof AttachmentUpdate
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof AttachmentUpdate
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof AttachmentUpdate
   */
  contentBase64?: string;
  /**
   *
   * @type {boolean}
   * @memberof AttachmentUpdate
   */
  anonymous?: boolean;
}
/**
 *
 * @export
 * @interface BeginPasswordResetRequest
 */
export interface BeginPasswordResetRequest {
  /**
   *
   * @type {string}
   * @memberof BeginPasswordResetRequest
   */
  emailAddress?: string;
}
/**
 *
 * @export
 * @interface CommunicationAttachment
 */
export interface CommunicationAttachment {
  /**
   *
   * @type {number}
   * @memberof CommunicationAttachment
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof CommunicationAttachment
   */
  messageId?: number;
  /**
   *
   * @type {number}
   * @memberof CommunicationAttachment
   */
  createdAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof CommunicationAttachment
   */
  anonymous?: boolean;
  /**
   *
   * @type {string}
   * @memberof CommunicationAttachment
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationAttachment
   */
  filename?: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationAttachment
   */
  previewFilename?: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationAttachment
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CommunicationAttachment
   */
  uploader?: string;
}
/**
 *
 * @export
 * @interface Conversation
 */
export interface Conversation {
  /**
   *
   * @type {number}
   * @memberof Conversation
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  type?: ConversationTypeEnum;
  /**
   *
   * @type {number}
   * @memberof Conversation
   */
  estateId?: number;
  /**
   *
   * @type {Set<number>}
   * @memberof Conversation
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {number}
   * @memberof Conversation
   */
  parentId?: number;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  internalNotes?: string;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  publishFrom?: string;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  publishTo?: string;
  /**
   *
   * @type {number}
   * @memberof Conversation
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof Conversation
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof Conversation
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {ServiceType}
   * @memberof Conversation
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {Array<AbstractMessage>}
   * @memberof Conversation
   */
  messages?: Array<AbstractMessage>;
  /**
   *
   * @type {Array<CommunicationAttachment>}
   * @memberof Conversation
   */
  attachments?: Array<CommunicationAttachment>;
  /**
   *
   * @type {boolean}
   * @memberof Conversation
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof Conversation
   */
  authorAccountId?: number;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  processingState?: ConversationProcessingStateEnum;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  publishingMode?: ConversationPublishingModeEnum;
  /**
   *
   * @type {boolean}
   * @memberof Conversation
   */
  published?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof Conversation
   */
  accessibleByTypes?: Array<ConversationAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof Conversation
   */
  accessibleByPersonIds?: Set<number>;
  /**
   *
   * @type {boolean}
   * @memberof Conversation
   */
  anonymous?: boolean;
  /**
   *
   * @type {Set<number>}
   * @memberof Conversation
   */
  assigneeIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof Conversation
   */
  author?: string;
}

export const ConversationTypeEnum = {
  Posting: "Posting",
  Conversation: "Conversation",
  Ticket: "Ticket",
} as const;

export type ConversationTypeEnum =
  (typeof ConversationTypeEnum)[keyof typeof ConversationTypeEnum];
export const ConversationProcessingStateEnum = {
  New: "NEW",
  InProgress: "IN_PROGRESS",
  WorkDone: "WORK_DONE",
  Solved: "SOLVED",
} as const;

export type ConversationProcessingStateEnum =
  (typeof ConversationProcessingStateEnum)[keyof typeof ConversationProcessingStateEnum];
export const ConversationPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type ConversationPublishingModeEnum =
  (typeof ConversationPublishingModeEnum)[keyof typeof ConversationPublishingModeEnum];
export const ConversationAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type ConversationAccessibleByTypesEnum =
  (typeof ConversationAccessibleByTypesEnum)[keyof typeof ConversationAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface Create
 */
export interface Create {
  /**
   *
   * @type {string}
   * @memberof Create
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Create
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof Create
   */
  contentBase64?: string;
}
/**
 *
 * @export
 * @interface CreateAccountRequest
 */
export interface CreateAccountRequest {
  /**
   *
   * @type {string}
   * @memberof CreateAccountRequest
   */
  emailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof CreateAccountRequest
   */
  password?: string;
  /**
   *
   * @type {Array<Role>}
   * @memberof CreateAccountRequest
   */
  roles?: Array<Role>;
  /**
   *
   * @type {number}
   * @memberof CreateAccountRequest
   */
  personId?: number;
  /**
   *
   * @type {NotificationSettings}
   * @memberof CreateAccountRequest
   */
  notificationSettings?: NotificationSettings;
}
/**
 *
 * @export
 * @interface CreateCommunicationAttachmentRequest
 */
export interface CreateCommunicationAttachmentRequest {
  /**
   *
   * @type {string}
   * @memberof CreateCommunicationAttachmentRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCommunicationAttachmentRequest
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof CreateCommunicationAttachmentRequest
   */
  contentBase64?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateCommunicationAttachmentRequest
   */
  anonymous?: boolean;
}
/**
 *
 * @export
 * @interface CreateConversationRequest
 */
export interface CreateConversationRequest {
  /**
   *
   * @type {number}
   * @memberof CreateConversationRequest
   */
  estateId: number;
  /**
   *
   * @type {Set<number>}
   * @memberof CreateConversationRequest
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof CreateConversationRequest
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof CreateConversationRequest
   */
  body?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateConversationRequest
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {ServiceType}
   * @memberof CreateConversationRequest
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {boolean}
   * @memberof CreateConversationRequest
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {Array<CreateCommunicationAttachmentRequest>}
   * @memberof CreateConversationRequest
   */
  attachments?: Array<CreateCommunicationAttachmentRequest>;
  /**
   *
   * @type {string}
   * @memberof CreateConversationRequest
   */
  publishingMode?: CreateConversationRequestPublishingModeEnum;
}

export const CreateConversationRequestPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type CreateConversationRequestPublishingModeEnum =
  (typeof CreateConversationRequestPublishingModeEnum)[keyof typeof CreateConversationRequestPublishingModeEnum];

/**
 *
 * @export
 * @interface CreateDocumentAttachmentRequest
 */
export interface CreateDocumentAttachmentRequest {
  /**
   *
   * @type {string}
   * @memberof CreateDocumentAttachmentRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDocumentAttachmentRequest
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof CreateDocumentAttachmentRequest
   */
  contentBase64?: string;
}
/**
 *
 * @export
 * @interface CreateDocumentCategoryRequest
 */
export interface CreateDocumentCategoryRequest {
  /**
   *
   * @type {string}
   * @memberof CreateDocumentCategoryRequest
   */
  name?: string;
}
/**
 *
 * @export
 * @interface CreateDocumentRequest
 */
export interface CreateDocumentRequest {
  /**
   *
   * @type {number}
   * @memberof CreateDocumentRequest
   */
  estateId: number;
  /**
   *
   * @type {string}
   * @memberof CreateDocumentRequest
   */
  title?: string;
  /**
   *
   * @type {Array<Create>}
   * @memberof CreateDocumentRequest
   */
  attachments?: Array<Create>;
  /**
   *
   * @type {DocumentCategory}
   * @memberof CreateDocumentRequest
   */
  category: DocumentCategory;
  /**
   *
   * @type {boolean}
   * @memberof CreateDocumentRequest
   */
  published?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateDocumentRequest
   */
  accessibleByTypes?: Array<CreateDocumentRequestAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof CreateDocumentRequest
   */
  accessibleByPersonIds?: Set<number>;
}

export const CreateDocumentRequestAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type CreateDocumentRequestAccessibleByTypesEnum =
  (typeof CreateDocumentRequestAccessibleByTypesEnum)[keyof typeof CreateDocumentRequestAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface CreateEstateRequest
 */
export interface CreateEstateRequest {
  /**
   *
   * @type {number}
   * @memberof CreateEstateRequest
   */
  propertyManagementId?: number;
  /**
   *
   * @type {string}
   * @memberof CreateEstateRequest
   */
  name?: string;
  /**
   *
   * @type {Address}
   * @memberof CreateEstateRequest
   */
  address?: Address;
  /**
   *
   * @type {Array<Create>}
   * @memberof CreateEstateRequest
   */
  livingUnits?: Array<Create>;
  /**
   *
   * @type {Array<ServiceType>}
   * @memberof CreateEstateRequest
   */
  serviceTypes?: Array<ServiceType>;
  /**
   *
   * @type {Array<DocumentCategory>}
   * @memberof CreateEstateRequest
   */
  documentCategories?: Array<DocumentCategory>;
  /**
   *
   * @type {Create}
   * @memberof CreateEstateRequest
   */
  image?: Create;
  /**
   *
   * @type {string}
   * @memberof CreateEstateRequest
   */
  infoText?: string;
}
/**
 *
 * @export
 * @interface CreateLivingUnitRequest
 */
export interface CreateLivingUnitRequest {
  /**
   *
   * @type {string}
   * @memberof CreateLivingUnitRequest
   */
  name?: string;
}
/**
 *
 * @export
 * @interface CreateMessageRequest
 */
export interface CreateMessageRequest {
  /**
   *
   * @type {string}
   * @memberof CreateMessageRequest
   */
  content?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreateMessageRequest
   */
  anonymous?: boolean;
  /**
   *
   * @type {Array<Create>}
   * @memberof CreateMessageRequest
   */
  attachments?: Array<Create>;
}
/**
 *
 * @export
 * @interface CreatePersonEntityRelationRequest
 */
export interface CreatePersonEntityRelationRequest {
  /**
   *
   * @type {number}
   * @memberof CreatePersonEntityRelationRequest
   */
  id?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof CreatePersonEntityRelationRequest
   */
  types?: Array<CreatePersonEntityRelationRequestTypesEnum>;
  /**
   *
   * @type {number}
   * @memberof CreatePersonEntityRelationRequest
   */
  estateId: number;
  /**
   *
   * @type {number}
   * @memberof CreatePersonEntityRelationRequest
   */
  livingUnitId?: number;
}

export const CreatePersonEntityRelationRequestTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type CreatePersonEntityRelationRequestTypesEnum =
  (typeof CreatePersonEntityRelationRequestTypesEnum)[keyof typeof CreatePersonEntityRelationRequestTypesEnum];

/**
 *
 * @export
 * @interface CreatePersonRequest
 */
export interface CreatePersonRequest {
  /**
   *
   * @type {string}
   * @memberof CreatePersonRequest
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonRequest
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonRequest
   */
  lastName?: string;
  /**
   *
   * @type {Address}
   * @memberof CreatePersonRequest
   */
  address?: Address;
  /**
   *
   * @type {Array<PhoneNumber>}
   * @memberof CreatePersonRequest
   */
  phoneNumbers?: Array<PhoneNumber>;
  /**
   *
   * @type {string}
   * @memberof CreatePersonRequest
   */
  taxId?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePersonRequest
   */
  company?: string;
  /**
   *
   * @type {Array<UpdateFromPerson>}
   * @memberof CreatePersonRequest
   */
  relations?: Array<UpdateFromPerson>;
  /**
   *
   * @type {Array<EmailField>}
   * @memberof CreatePersonRequest
   */
  emailAddresses?: Array<EmailField>;
  /**
   *
   * @type {number}
   * @memberof CreatePersonRequest
   */
  propertyManagerOfId?: number;
  /**
   *
   * @type {Array<number>}
   * @memberof CreatePersonRequest
   */
  filteredServiceTypeIds?: Array<number>;
  /**
   *
   * @type {boolean}
   * @memberof CreatePersonRequest
   */
  quickEntry?: boolean;
}
/**
 *
 * @export
 * @interface CreatePostingRequest
 */
export interface CreatePostingRequest {
  /**
   *
   * @type {number}
   * @memberof CreatePostingRequest
   */
  estateId: number;
  /**
   *
   * @type {Set<number>}
   * @memberof CreatePostingRequest
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof CreatePostingRequest
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePostingRequest
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePostingRequest
   */
  publishFrom?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePostingRequest
   */
  publishTo?: string;
  /**
   *
   * @type {boolean}
   * @memberof CreatePostingRequest
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {Array<CreateCommunicationAttachmentRequest>}
   * @memberof CreatePostingRequest
   */
  attachments?: Array<CreateCommunicationAttachmentRequest>;
  /**
   *
   * @type {string}
   * @memberof CreatePostingRequest
   */
  publishingMode?: CreatePostingRequestPublishingModeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof CreatePostingRequest
   */
  accessibleByTypes?: Array<CreatePostingRequestAccessibleByTypesEnum>;
}

export const CreatePostingRequestPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type CreatePostingRequestPublishingModeEnum =
  (typeof CreatePostingRequestPublishingModeEnum)[keyof typeof CreatePostingRequestPublishingModeEnum];
export const CreatePostingRequestAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type CreatePostingRequestAccessibleByTypesEnum =
  (typeof CreatePostingRequestAccessibleByTypesEnum)[keyof typeof CreatePostingRequestAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface CreatePropertyManagementAttachmentRequest
 */
export interface CreatePropertyManagementAttachmentRequest {
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementAttachmentRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementAttachmentRequest
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementAttachmentRequest
   */
  contentBase64?: string;
}
/**
 *
 * @export
 * @interface CreatePropertyManagementRequest
 */
export interface CreatePropertyManagementRequest {
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  emailAddress?: string;
  /**
   *
   * @type {Address}
   * @memberof CreatePropertyManagementRequest
   */
  address?: Address;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  customColorPrimary?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext1?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext2?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext3?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext4?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext5?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext6?: string;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  freetext7?: string;
  /**
   *
   * @type {Create}
   * @memberof CreatePropertyManagementRequest
   */
  logo?: Create;
  /**
   *
   * @type {InvitationCustomization}
   * @memberof CreatePropertyManagementRequest
   */
  invitationCustomization?: InvitationCustomization;
  /**
   *
   * @type {string}
   * @memberof CreatePropertyManagementRequest
   */
  phoneNumber?: string;
}
/**
 *
 * @export
 * @interface CreateTicketRequest
 */
export interface CreateTicketRequest {
  /**
   *
   * @type {number}
   * @memberof CreateTicketRequest
   */
  estateId: number;
  /**
   *
   * @type {Set<number>}
   * @memberof CreateTicketRequest
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {number}
   * @memberof CreateTicketRequest
   */
  parentId?: number;
  /**
   *
   * @type {string}
   * @memberof CreateTicketRequest
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTicketRequest
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof CreateTicketRequest
   */
  internalNotes?: string;
  /**
   *
   * @type {Set<number>}
   * @memberof CreateTicketRequest
   */
  assigneeIds?: Set<number>;
  /**
   *
   * @type {boolean}
   * @memberof CreateTicketRequest
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {ServiceType}
   * @memberof CreateTicketRequest
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {boolean}
   * @memberof CreateTicketRequest
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {Array<CreateCommunicationAttachmentRequest>}
   * @memberof CreateTicketRequest
   */
  attachments?: Array<CreateCommunicationAttachmentRequest>;
  /**
   *
   * @type {string}
   * @memberof CreateTicketRequest
   */
  publishingMode?: CreateTicketRequestPublishingModeEnum;
  /**
   *
   * @type {string}
   * @memberof CreateTicketRequest
   */
  processingState?: CreateTicketRequestProcessingStateEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof CreateTicketRequest
   */
  accessibleByTypes?: Array<CreateTicketRequestAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof CreateTicketRequest
   */
  accessibleByPersonIds?: Set<number>;
  /**
   *
   * @type {boolean}
   * @memberof CreateTicketRequest
   */
  anonymous?: boolean;
}

export const CreateTicketRequestPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type CreateTicketRequestPublishingModeEnum =
  (typeof CreateTicketRequestPublishingModeEnum)[keyof typeof CreateTicketRequestPublishingModeEnum];
export const CreateTicketRequestProcessingStateEnum = {
  New: "NEW",
  InProgress: "IN_PROGRESS",
  WorkDone: "WORK_DONE",
  Solved: "SOLVED",
} as const;

export type CreateTicketRequestProcessingStateEnum =
  (typeof CreateTicketRequestProcessingStateEnum)[keyof typeof CreateTicketRequestProcessingStateEnum];
export const CreateTicketRequestAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type CreateTicketRequestAccessibleByTypesEnum =
  (typeof CreateTicketRequestAccessibleByTypesEnum)[keyof typeof CreateTicketRequestAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface Document
 */
export interface Document {
  /**
   *
   * @type {number}
   * @memberof Document
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof Document
   */
  estateId?: number;
  /**
   *
   * @type {string}
   * @memberof Document
   */
  title?: string;
  /**
   *
   * @type {number}
   * @memberof Document
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof Document
   */
  updatedAt?: number;
  /**
   *
   * @type {DocumentCategory}
   * @memberof Document
   */
  category?: DocumentCategory;
  /**
   *
   * @type {boolean}
   * @memberof Document
   */
  published?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof Document
   */
  accessibleByTypes?: Array<DocumentAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof Document
   */
  accessibleByPersonIds?: Set<number>;
  /**
   *
   * @type {Array<DocumentAttachment>}
   * @memberof Document
   */
  attachments?: Array<DocumentAttachment>;
}

export const DocumentAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type DocumentAccessibleByTypesEnum =
  (typeof DocumentAccessibleByTypesEnum)[keyof typeof DocumentAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface DocumentAttachment
 */
export interface DocumentAttachment {
  /**
   *
   * @type {number}
   * @memberof DocumentAttachment
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof DocumentAttachment
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentAttachment
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentAttachment
   */
  filename?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentAttachment
   */
  previewFilename?: string;
  /**
   *
   * @type {string}
   * @memberof DocumentAttachment
   */
  name?: string;
}
/**
 *
 * @export
 * @interface DocumentCategory
 */
export interface DocumentCategory {
  /**
   *
   * @type {number}
   * @memberof DocumentCategory
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof DocumentCategory
   */
  name: string;
}
/**
 *
 * @export
 * @interface Duration
 */
export interface Duration {
  /**
   *
   * @type {number}
   * @memberof Duration
   */
  seconds?: number;
  /**
   *
   * @type {number}
   * @memberof Duration
   */
  nano?: number;
  /**
   *
   * @type {Array<TemporalUnit>}
   * @memberof Duration
   */
  units?: Array<TemporalUnit>;
  /**
   *
   * @type {boolean}
   * @memberof Duration
   */
  zero?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof Duration
   */
  negative?: boolean;
}
/**
 *
 * @export
 * @interface EmailAddressAndPassword
 */
export interface EmailAddressAndPassword {
  /**
   *
   * @type {string}
   * @memberof EmailAddressAndPassword
   */
  emailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof EmailAddressAndPassword
   */
  password?: string;
}
/**
 *
 * @export
 * @interface EmailField
 */
export interface EmailField {
  /**
   *
   * @type {string}
   * @memberof EmailField
   */
  email?: string;
}
/**
 *
 * @export
 * @interface Estate
 */
export interface Estate {
  /**
   *
   * @type {number}
   * @memberof Estate
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Estate
   */
  name?: string;
  /**
   *
   * @type {Address}
   * @memberof Estate
   */
  address?: Address;
  /**
   *
   * @type {number}
   * @memberof Estate
   */
  createdAt?: number;
  /**
   *
   * @type {Array<LivingUnit>}
   * @memberof Estate
   */
  livingUnits?: Array<LivingUnit>;
  /**
   *
   * @type {Set<ServiceType>}
   * @memberof Estate
   */
  serviceTypes?: Set<ServiceType>;
  /**
   *
   * @type {Set<DocumentCategory>}
   * @memberof Estate
   */
  documentCategories?: Set<DocumentCategory>;
  /**
   *
   * @type {Array<PersonEntityRelation>}
   * @memberof Estate
   */
  relations?: Array<PersonEntityRelation>;
  /**
   *
   * @type {number}
   * @memberof Estate
   */
  propertyManagementId?: number;
  /**
   *
   * @type {string}
   * @memberof Estate
   */
  infoText?: string;
  /**
   *
   * @type {number}
   * @memberof Estate
   */
  noAssignedAccounts?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof Estate
   */
  assignedAccountNames?: Array<string>;
  /**
   *
   * @type {string}
   * @memberof Estate
   */
  imageFilename?: string;
}
/**
 *
 * @export
 * @interface EstateContact
 */
export interface EstateContact {
  /**
   *
   * @type {number}
   * @memberof EstateContact
   */
  id?: number;
  /**
   *
   * @type {LivingUnit}
   * @memberof EstateContact
   */
  livingUnit?: LivingUnit;
  /**
   *
   * @type {string}
   * @memberof EstateContact
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof EstateContact
   */
  lastName?: string;
  /**
   *
   * @type {Set<string>}
   * @memberof EstateContact
   */
  types?: Set<EstateContactTypesEnum>;
}

export const EstateContactTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type EstateContactTypesEnum =
  (typeof EstateContactTypesEnum)[keyof typeof EstateContactTypesEnum];

/**
 *
 * @export
 * @interface EstateManager
 */
export interface EstateManager {
  /**
   *
   * @type {number}
   * @memberof EstateManager
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof EstateManager
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof EstateManager
   */
  lastName?: string;
  /**
   *
   * @type {string}
   * @memberof EstateManager
   */
  initials?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof EstateManager
   */
  relations?: Array<EstateManagerRelationsEnum>;
  /**
   *
   * @type {boolean}
   * @memberof EstateManager
   */
  responsibleForEstate?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EstateManager
   */
  propertyManager?: boolean;
}

export const EstateManagerRelationsEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type EstateManagerRelationsEnum =
  (typeof EstateManagerRelationsEnum)[keyof typeof EstateManagerRelationsEnum];

/**
 *
 * @export
 * @interface FinishPasswordResetRequest
 */
export interface FinishPasswordResetRequest {
  /**
   *
   * @type {string}
   * @memberof FinishPasswordResetRequest
   */
  token?: string;
  /**
   *
   * @type {string}
   * @memberof FinishPasswordResetRequest
   */
  password?: string;
}
/**
 *
 * @export
 * @interface FinishPasswordResetResponse
 */
export interface FinishPasswordResetResponse {
  /**
   *
   * @type {boolean}
   * @memberof FinishPasswordResetResponse
   */
  passwordMissing?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof FinishPasswordResetResponse
   */
  finished?: boolean;
}
/**
 *
 * @export
 * @interface GetCommunicationAttachmentSignatureResponse
 */
export interface GetCommunicationAttachmentSignatureResponse {
  /**
   *
   * @type {string}
   * @memberof GetCommunicationAttachmentSignatureResponse
   */
  signature?: string;
  /**
   *
   * @type {string}
   * @memberof GetCommunicationAttachmentSignatureResponse
   */
  path?: string;
}
/**
 *
 * @export
 * @interface GetDocumentAttachmentSignatureResponse
 */
export interface GetDocumentAttachmentSignatureResponse {
  /**
   *
   * @type {string}
   * @memberof GetDocumentAttachmentSignatureResponse
   */
  signature?: string;
  /**
   *
   * @type {string}
   * @memberof GetDocumentAttachmentSignatureResponse
   */
  path?: string;
}
/**
 *
 * @export
 * @interface ImportXlsResponse
 */
export interface ImportXlsResponse {
  /**
   *
   * @type {boolean}
   * @memberof ImportXlsResponse
   */
  error?: boolean;
  /**
   *
   * @type {Array<Result>}
   * @memberof ImportXlsResponse
   */
  results?: Array<Result>;
}
/**
 *
 * @export
 * @interface Info
 */
export interface Info {
  /**
   *
   * @type {string}
   * @memberof Info
   */
  id?: string;
  /**
   *
   * @type {string}
   * @memberof Info
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof Info
   */
  mimeType?: string;
  /**
   *
   * @type {number}
   * @memberof Info
   */
  contentLength?: number;
  /**
   *
   * @type {string}
   * @memberof Info
   */
  extension?: string;
}
/**
 *
 * @export
 * @interface InvitationCustomization
 */
export interface InvitationCustomization {
  /**
   *
   * @type {string}
   * @memberof InvitationCustomization
   */
  beforeCallToActionText?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationCustomization
   */
  beforeCallToActionHtml?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationCustomization
   */
  afterCallToActionText?: string;
  /**
   *
   * @type {string}
   * @memberof InvitationCustomization
   */
  afterCallToActionHtml?: string;
}
/**
 *
 * @export
 * @interface InvitePersonRequest
 */
export interface InvitePersonRequest {
  /**
   *
   * @type {number}
   * @memberof InvitePersonRequest
   */
  id: number;
}
/**
 *
 * @export
 * @interface InvitePersonResponse
 */
export interface InvitePersonResponse {
  /**
   *
   * @type {number}
   * @memberof InvitePersonResponse
   */
  id?: number;
}
/**
 *
 * @export
 * @interface Item
 */
export interface Item {
  /**
   *
   * @type {ItemInfo}
   * @memberof Item
   */
  rows?: ItemInfo;
  /**
   *
   * @type {ItemInfo}
   * @memberof Item
   */
  estates?: ItemInfo;
  /**
   *
   * @type {ItemInfo}
   * @memberof Item
   */
  livingUnits?: ItemInfo;
  /**
   *
   * @type {ItemInfo}
   * @memberof Item
   */
  persons?: ItemInfo;
}
/**
 *
 * @export
 * @interface ItemInfo
 */
export interface ItemInfo {
  /**
   *
   * @type {number}
   * @memberof ItemInfo
   */
  read?: number;
  /**
   *
   * @type {number}
   * @memberof ItemInfo
   */
  created?: number;
  /**
   *
   * @type {number}
   * @memberof ItemInfo
   */
  updated?: number;
  /**
   *
   * @type {number}
   * @memberof ItemInfo
   */
  rejected?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof ItemInfo
   */
  createdInfo?: Array<string>;
  /**
   *
   * @type {Array<string>}
   * @memberof ItemInfo
   */
  updatedInfo?: Array<string>;
}
/**
 *
 * @export
 * @interface LivingUnit
 */
export interface LivingUnit {
  /**
   *
   * @type {number}
   * @memberof LivingUnit
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof LivingUnit
   */
  name?: string;
  /**
   *
   * @type {number}
   * @memberof LivingUnit
   */
  ownershipCommunityShares?: number;
  /**
   *
   * @type {number}
   * @memberof LivingUnit
   */
  sizeSqm?: number;
  /**
   *
   * @type {number}
   * @memberof LivingUnit
   */
  createdAt?: number;
  /**
   *
   * @type {Array<PersonEntityRelation>}
   * @memberof LivingUnit
   */
  relations?: Array<PersonEntityRelation>;
}
/**
 *
 * @export
 * @interface Message
 */
export interface Message {
  /**
   *
   * @type {number}
   * @memberof Message
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof Message
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof Message
   */
  content?: string;
  /**
   *
   * @type {boolean}
   * @memberof Message
   */
  anonymous?: boolean;
  /**
   *
   * @type {Array<CommunicationAttachment>}
   * @memberof Message
   */
  attachments?: Array<CommunicationAttachment>;
  /**
   *
   * @type {string}
   * @memberof Message
   */
  author?: string;
}
/**
 *
 * @export
 * @interface NotificationSettings
 */
export interface NotificationSettings {
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onNewPosting?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onNewPrivateTicket?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onPrivateTicketAnswer?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onNewPublicTicket?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onPublicTicketAnswer?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onPublicTicketStatusChange?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof NotificationSettings
   */
  onNewDocument?: boolean;
}
/**
 *
 * @export
 * @interface Occupant
 */
export interface Occupant extends Role {
  /**
   *
   * @type {string}
   * @memberof Occupant
   */
  estateId: string;
  /**
   *
   * @type {string}
   * @memberof Occupant
   */
  livingUnitId?: string;
}
/**
 *
 * @export
 * @interface PaymentSettings
 */
export interface PaymentSettings {
  /**
   *
   * @type {string}
   * @memberof PaymentSettings
   */
  accountLevel?: PaymentSettingsAccountLevelEnum;
  /**
   *
   * @type {string}
   * @memberof PaymentSettings
   */
  paymentType?: PaymentSettingsPaymentTypeEnum;
  /**
   *
   * @type {number}
   * @memberof PaymentSettings
   */
  monthlyRate?: number;
}

export const PaymentSettingsAccountLevelEnum = {
  Basic: "BASIC",
  Start: "START",
  Plus: "PLUS",
  Pro: "PRO",
  Top: "TOP",
  Elite: "ELITE",
  Premium: "PREMIUM",
  Enterprise: "ENTERPRISE",
} as const;

export type PaymentSettingsAccountLevelEnum =
  (typeof PaymentSettingsAccountLevelEnum)[keyof typeof PaymentSettingsAccountLevelEnum];
export const PaymentSettingsPaymentTypeEnum = {
  Invoice: "INVOICE",
} as const;

export type PaymentSettingsPaymentTypeEnum =
  (typeof PaymentSettingsPaymentTypeEnum)[keyof typeof PaymentSettingsPaymentTypeEnum];

/**
 *
 * @export
 * @interface Person
 */
export interface Person {
  /**
   *
   * @type {number}
   * @memberof Person
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  lastName?: string;
  /**
   *
   * @type {Address}
   * @memberof Person
   */
  address?: Address;
  /**
   *
   * @type {Array<PhoneNumber>}
   * @memberof Person
   */
  phoneNumbers?: Array<PhoneNumber>;
  /**
   *
   * @type {Array<EmailField>}
   * @memberof Person
   */
  emailAddresses?: Array<EmailField>;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  taxId?: string;
  /**
   *
   * @type {number}
   * @memberof Person
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  company?: string;
  /**
   *
   * @type {Array<PersonEntityRelation>}
   * @memberof Person
   */
  relations?: Array<PersonEntityRelation>;
  /**
   *
   * @type {number}
   * @memberof Person
   */
  lastLoginAt?: number;
  /**
   *
   * @type {number}
   * @memberof Person
   */
  propertyManagerOfId?: number;
  /**
   *
   * @type {string}
   * @memberof Person
   */
  invitationState?: PersonInvitationStateEnum;
}

export const PersonInvitationStateEnum = {
  None: "none",
  Invited: "invited",
  AccountCreated: "accountCreated",
} as const;

export type PersonInvitationStateEnum =
  (typeof PersonInvitationStateEnum)[keyof typeof PersonInvitationStateEnum];

/**
 *
 * @export
 * @interface PersonEntityRelation
 */
export interface PersonEntityRelation {
  /**
   *
   * @type {number}
   * @memberof PersonEntityRelation
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof PersonEntityRelation
   */
  personId?: number;
  /**
   *
   * @type {number}
   * @memberof PersonEntityRelation
   */
  estateId?: number;
  /**
   *
   * @type {number}
   * @memberof PersonEntityRelation
   */
  livingUnitId?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof PersonEntityRelation
   */
  types?: Array<PersonEntityRelationTypesEnum>;
  /**
   *
   * @type {number}
   * @memberof PersonEntityRelation
   */
  createdAt?: number;
}

export const PersonEntityRelationTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type PersonEntityRelationTypesEnum =
  (typeof PersonEntityRelationTypesEnum)[keyof typeof PersonEntityRelationTypesEnum];

/**
 *
 * @export
 * @interface PhoneNumber
 */
export interface PhoneNumber {
  /**
   *
   * @type {string}
   * @memberof PhoneNumber
   */
  type?: PhoneNumberTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PhoneNumber
   */
  value?: string;
}

export const PhoneNumberTypeEnum = {
  Landline: "LANDLINE",
  Mobile: "MOBILE",
  Fax: "FAX",
} as const;

export type PhoneNumberTypeEnum =
  (typeof PhoneNumberTypeEnum)[keyof typeof PhoneNumberTypeEnum];

/**
 *
 * @export
 * @interface Posting
 */
export interface Posting {
  /**
   *
   * @type {number}
   * @memberof Posting
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  type?: PostingTypeEnum;
  /**
   *
   * @type {number}
   * @memberof Posting
   */
  estateId?: number;
  /**
   *
   * @type {Set<number>}
   * @memberof Posting
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {number}
   * @memberof Posting
   */
  parentId?: number;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  internalNotes?: string;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  publishFrom?: string;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  publishTo?: string;
  /**
   *
   * @type {number}
   * @memberof Posting
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof Posting
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof Posting
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {Array<AbstractMessage>}
   * @memberof Posting
   */
  messages?: Array<AbstractMessage>;
  /**
   *
   * @type {Array<CommunicationAttachment>}
   * @memberof Posting
   */
  attachments?: Array<CommunicationAttachment>;
  /**
   *
   * @type {boolean}
   * @memberof Posting
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof Posting
   */
  authorAccountId?: number;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  processingState?: PostingProcessingStateEnum;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  publishingMode?: PostingPublishingModeEnum;
  /**
   *
   * @type {boolean}
   * @memberof Posting
   */
  published?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof Posting
   */
  accessibleByTypes?: Array<PostingAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof Posting
   */
  accessibleByPersonIds?: Set<number>;
  /**
   *
   * @type {boolean}
   * @memberof Posting
   */
  anonymous?: boolean;
  /**
   *
   * @type {Set<number>}
   * @memberof Posting
   */
  assigneeIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof Posting
   */
  author?: string;
}

export const PostingTypeEnum = {
  Posting: "Posting",
  Conversation: "Conversation",
  Ticket: "Ticket",
} as const;

export type PostingTypeEnum =
  (typeof PostingTypeEnum)[keyof typeof PostingTypeEnum];
export const PostingProcessingStateEnum = {
  New: "NEW",
  InProgress: "IN_PROGRESS",
  WorkDone: "WORK_DONE",
  Solved: "SOLVED",
} as const;

export type PostingProcessingStateEnum =
  (typeof PostingProcessingStateEnum)[keyof typeof PostingProcessingStateEnum];
export const PostingPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type PostingPublishingModeEnum =
  (typeof PostingPublishingModeEnum)[keyof typeof PostingPublishingModeEnum];
export const PostingAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type PostingAccessibleByTypesEnum =
  (typeof PostingAccessibleByTypesEnum)[keyof typeof PostingAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface PropertyManagement
 */
export interface PropertyManagement {
  /**
   *
   * @type {number}
   * @memberof PropertyManagement
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  emailAddress?: string;
  /**
   *
   * @type {Address}
   * @memberof PropertyManagement
   */
  address?: Address;
  /**
   *
   * @type {number}
   * @memberof PropertyManagement
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  customColorPrimary?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext1?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext2?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext3?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext4?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext5?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext6?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  freetext7?: string;
  /**
   *
   * @type {PropertyManagementAttachment}
   * @memberof PropertyManagement
   */
  logo?: PropertyManagementAttachment;
  /**
   *
   * @type {InvitationCustomization}
   * @memberof PropertyManagement
   */
  invitationCustomization?: InvitationCustomization;
  /**
   *
   * @type {PaymentSettings}
   * @memberof PropertyManagement
   */
  paymentSettings?: PaymentSettings;
  /**
   *
   * @type {string}
   * @memberof PropertyManagement
   */
  phoneNumber?: string;
  /**
   *
   * @type {Array<Person>}
   * @memberof PropertyManagement
   */
  contacts?: Array<Person>;
  /**
   *
   * @type {Array<Estate>}
   * @memberof PropertyManagement
   */
  estates?: Array<Estate>;
}
/**
 *
 * @export
 * @interface PropertyManagementAttachment
 */
export interface PropertyManagementAttachment {
  /**
   *
   * @type {number}
   * @memberof PropertyManagementAttachment
   */
  id?: number;
  /**
   *
   * @type {number}
   * @memberof PropertyManagementAttachment
   */
  createdAt?: number;
  /**
   *
   * @type {string}
   * @memberof PropertyManagementAttachment
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagementAttachment
   */
  filename?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagementAttachment
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof PropertyManagementAttachment
   */
  uploader?: string;
}
/**
 *
 * @export
 * @interface PropertyManager
 */
export interface PropertyManager extends Role {
  /**
   *
   * @type {number}
   * @memberof PropertyManager
   */
  id: number;
}
/**
 *
 * @export
 * @interface RegisterPropertyManagementRequest
 */
export interface RegisterPropertyManagementRequest {
  /**
   *
   * @type {string}
   * @memberof RegisterPropertyManagementRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof RegisterPropertyManagementRequest
   */
  emailAddress?: string;
  /**
   *
   * @type {string}
   * @memberof RegisterPropertyManagementRequest
   */
  password?: string;
  /**
   *
   * @type {string}
   * @memberof RegisterPropertyManagementRequest
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof RegisterPropertyManagementRequest
   */
  lastName?: string;
  /**
   *
   * @type {Address}
   * @memberof RegisterPropertyManagementRequest
   */
  address: Address;
  /**
   *
   * @type {Array<PhoneNumber>}
   * @memberof RegisterPropertyManagementRequest
   */
  phoneNumbers?: Array<PhoneNumber>;
  /**
   *
   * @type {string}
   * @memberof RegisterPropertyManagementRequest
   */
  phoneNumber?: string;
}
/**
 *
 * @export
 * @interface Result
 */
export interface Result {
  /**
   *
   * @type {string}
   * @memberof Result
   */
  format?: string;
  /**
   *
   * @type {Array<Item>}
   * @memberof Result
   */
  items?: Array<Item>;
}
/**
 *
 * @export
 * @interface Role
 */
export interface Role {
  /**
   *
   * @type {string}
   * @memberof Role
   */
  type?: string;
}
/**
 *
 * @export
 * @interface SearchResult
 */
export interface SearchResult {
  /**
   *
   * @type {string}
   * @memberof SearchResult
   */
  unit?: string;
  /**
   *
   * @type {Array<object>}
   * @memberof SearchResult
   */
  items?: Array<object>;
  /**
   *
   * @type {number}
   * @memberof SearchResult
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResult
   */
  rangeFrom?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResult
   */
  rangeTo?: number;
}
/**
 *
 * @export
 * @interface SearchResultCommunicationAttachment
 */
export interface SearchResultCommunicationAttachment {
  /**
   *
   * @type {string}
   * @memberof SearchResultCommunicationAttachment
   */
  unit?: string;
  /**
   *
   * @type {Array<CommunicationAttachment>}
   * @memberof SearchResultCommunicationAttachment
   */
  items?: Array<CommunicationAttachment>;
  /**
   *
   * @type {number}
   * @memberof SearchResultCommunicationAttachment
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultCommunicationAttachment
   */
  rangeFrom?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultCommunicationAttachment
   */
  rangeTo?: number;
}
/**
 *
 * @export
 * @interface SearchResultDocumentAttachment
 */
export interface SearchResultDocumentAttachment {
  /**
   *
   * @type {string}
   * @memberof SearchResultDocumentAttachment
   */
  unit?: string;
  /**
   *
   * @type {Array<DocumentAttachment>}
   * @memberof SearchResultDocumentAttachment
   */
  items?: Array<DocumentAttachment>;
  /**
   *
   * @type {number}
   * @memberof SearchResultDocumentAttachment
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultDocumentAttachment
   */
  rangeFrom?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultDocumentAttachment
   */
  rangeTo?: number;
}
/**
 *
 * @export
 * @interface SearchResultEstateContact
 */
export interface SearchResultEstateContact {
  /**
   *
   * @type {string}
   * @memberof SearchResultEstateContact
   */
  unit?: string;
  /**
   *
   * @type {Array<EstateContact>}
   * @memberof SearchResultEstateContact
   */
  items?: Array<EstateContact>;
  /**
   *
   * @type {number}
   * @memberof SearchResultEstateContact
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultEstateContact
   */
  rangeFrom?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultEstateContact
   */
  rangeTo?: number;
}
/**
 *
 * @export
 * @interface SearchResultPersonEntityRelation
 */
export interface SearchResultPersonEntityRelation {
  /**
   *
   * @type {string}
   * @memberof SearchResultPersonEntityRelation
   */
  unit?: string;
  /**
   *
   * @type {Array<PersonEntityRelation>}
   * @memberof SearchResultPersonEntityRelation
   */
  items?: Array<PersonEntityRelation>;
  /**
   *
   * @type {number}
   * @memberof SearchResultPersonEntityRelation
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultPersonEntityRelation
   */
  rangeFrom?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultPersonEntityRelation
   */
  rangeTo?: number;
}
/**
 *
 * @export
 * @interface SearchResultServiceType
 */
export interface SearchResultServiceType {
  /**
   *
   * @type {string}
   * @memberof SearchResultServiceType
   */
  unit?: string;
  /**
   *
   * @type {Array<ServiceType>}
   * @memberof SearchResultServiceType
   */
  items?: Array<ServiceType>;
  /**
   *
   * @type {number}
   * @memberof SearchResultServiceType
   */
  total?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultServiceType
   */
  rangeFrom?: number;
  /**
   *
   * @type {number}
   * @memberof SearchResultServiceType
   */
  rangeTo?: number;
}
/**
 *
 * @export
 * @interface ServiceType
 */
export interface ServiceType {
  /**
   *
   * @type {number}
   * @memberof ServiceType
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof ServiceType
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof ServiceType
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof ServiceType
   */
  iconName?: string;
}
/**
 *
 * @export
 * @interface Session
 */
export interface Session {
  /**
   *
   * @type {string}
   * @memberof Session
   */
  token?: string;
  /**
   *
   * @type {User}
   * @memberof Session
   */
  user?: User;
  /**
   *
   * @type {Duration}
   * @memberof Session
   */
  ttl?: Duration;
  /**
   *
   * @type {number}
   * @memberof Session
   */
  timeout?: number;
  /**
   *
   * @type {boolean}
   * @memberof Session
   */
  valid?: boolean;
  /**
   *
   * @type {string}
   * @memberof Session
   */
  name?: string;
}
/**
 *
 * @export
 * @interface TemporalUnit
 */
export interface TemporalUnit {
  /**
   *
   * @type {boolean}
   * @memberof TemporalUnit
   */
  timeBased?: boolean;
  /**
   *
   * @type {Duration}
   * @memberof TemporalUnit
   */
  duration?: Duration;
  /**
   *
   * @type {boolean}
   * @memberof TemporalUnit
   */
  dateBased?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TemporalUnit
   */
  durationEstimated?: boolean;
}
/**
 *
 * @export
 * @interface Ticket
 */
export interface Ticket {
  /**
   *
   * @type {number}
   * @memberof Ticket
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  type?: TicketTypeEnum;
  /**
   *
   * @type {number}
   * @memberof Ticket
   */
  estateId?: number;
  /**
   *
   * @type {Set<number>}
   * @memberof Ticket
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {number}
   * @memberof Ticket
   */
  parentId?: number;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  internalNotes?: string;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  publishFrom?: string;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  publishTo?: string;
  /**
   *
   * @type {number}
   * @memberof Ticket
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof Ticket
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof Ticket
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {ServiceType}
   * @memberof Ticket
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {Array<AbstractMessage>}
   * @memberof Ticket
   */
  messages?: Array<AbstractMessage>;
  /**
   *
   * @type {Array<CommunicationAttachment>}
   * @memberof Ticket
   */
  attachments?: Array<CommunicationAttachment>;
  /**
   *
   * @type {boolean}
   * @memberof Ticket
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {number}
   * @memberof Ticket
   */
  authorAccountId?: number;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  processingState?: TicketProcessingStateEnum;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  publishingMode?: TicketPublishingModeEnum;
  /**
   *
   * @type {boolean}
   * @memberof Ticket
   */
  published?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof Ticket
   */
  accessibleByTypes?: Array<TicketAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof Ticket
   */
  accessibleByPersonIds?: Set<number>;
  /**
   *
   * @type {boolean}
   * @memberof Ticket
   */
  anonymous?: boolean;
  /**
   *
   * @type {Set<number>}
   * @memberof Ticket
   */
  assigneeIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof Ticket
   */
  author?: string;
}

export const TicketTypeEnum = {
  Posting: "Posting",
  Conversation: "Conversation",
  Ticket: "Ticket",
} as const;

export type TicketTypeEnum =
  (typeof TicketTypeEnum)[keyof typeof TicketTypeEnum];
export const TicketProcessingStateEnum = {
  New: "NEW",
  InProgress: "IN_PROGRESS",
  WorkDone: "WORK_DONE",
  Solved: "SOLVED",
} as const;

export type TicketProcessingStateEnum =
  (typeof TicketProcessingStateEnum)[keyof typeof TicketProcessingStateEnum];
export const TicketPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type TicketPublishingModeEnum =
  (typeof TicketPublishingModeEnum)[keyof typeof TicketPublishingModeEnum];
export const TicketAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type TicketAccessibleByTypesEnum =
  (typeof TicketAccessibleByTypesEnum)[keyof typeof TicketAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface TicketManager
 */
export interface TicketManager extends Role {}
/**
 *
 * @export
 * @interface TicketOverviewData
 */
export interface TicketOverviewData {
  /**
   *
   * @type {number}
   * @memberof TicketOverviewData
   */
  communicationId?: number;
  /**
   *
   * @type {number}
   * @memberof TicketOverviewData
   */
  estateId?: number;
  /**
   *
   * @type {string}
   * @memberof TicketOverviewData
   */
  estateName?: string;
  /**
   *
   * @type {string}
   * @memberof TicketOverviewData
   */
  authorName?: string;
  /**
   *
   * @type {number}
   * @memberof TicketOverviewData
   */
  parentId?: number;
  /**
   *
   * @type {string}
   * @memberof TicketOverviewData
   */
  subject?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof TicketOverviewData
   */
  assigneeNames?: Array<string>;
  /**
   *
   * @type {ServiceType}
   * @memberof TicketOverviewData
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {number}
   * @memberof TicketOverviewData
   */
  createdAt?: number;
  /**
   *
   * @type {number}
   * @memberof TicketOverviewData
   */
  updatedAt?: number;
  /**
   *
   * @type {boolean}
   * @memberof TicketOverviewData
   */
  anonymous?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TicketOverviewData
   */
  hasSubTickets?: boolean;
  /**
   *
   * @type {number}
   * @memberof TicketOverviewData
   */
  noSubtickets?: number;
  /**
   *
   * @type {boolean}
   * @memberof TicketOverviewData
   */
  hasAttachments?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof TicketOverviewData
   */
  hasMessages?: boolean;
  /**
   *
   * @type {string}
   * @memberof TicketOverviewData
   */
  processingState?: TicketOverviewDataProcessingStateEnum;
  /**
   *
   * @type {string}
   * @memberof TicketOverviewData
   */
  publishingMode?: TicketOverviewDataPublishingModeEnum;
}

export const TicketOverviewDataProcessingStateEnum = {
  New: "NEW",
  InProgress: "IN_PROGRESS",
  WorkDone: "WORK_DONE",
  Solved: "SOLVED",
} as const;

export type TicketOverviewDataProcessingStateEnum =
  (typeof TicketOverviewDataProcessingStateEnum)[keyof typeof TicketOverviewDataProcessingStateEnum];
export const TicketOverviewDataPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type TicketOverviewDataPublishingModeEnum =
  (typeof TicketOverviewDataPublishingModeEnum)[keyof typeof TicketOverviewDataPublishingModeEnum];

/**
 *
 * @export
 * @interface Update
 */
export interface Update {
  /**
   *
   * @type {number}
   * @memberof Update
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof Update
   */
  name?: string;
}
/**
 *
 * @export
 * @interface UpdateAccountRequest
 */
export interface UpdateAccountRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateAccountRequest
   */
  newPassword?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateAccountRequest
   */
  emailAddress?: string;
  /**
   *
   * @type {number}
   * @memberof UpdateAccountRequest
   */
  personId?: number;
  /**
   *
   * @type {NotificationSettings}
   * @memberof UpdateAccountRequest
   */
  notificationSettings?: NotificationSettings;
  /**
   *
   * @type {Array<number>}
   * @memberof UpdateAccountRequest
   */
  assignedEstateIds?: Array<number>;
}
/**
 *
 * @export
 * @interface UpdateAssignedEstatesRequest
 */
export interface UpdateAssignedEstatesRequest {
  /**
   *
   * @type {Array<number>}
   * @memberof UpdateAssignedEstatesRequest
   */
  assignedEstateIds?: Array<number>;
}
/**
 *
 * @export
 * @interface UpdateConversationRequest
 */
export interface UpdateConversationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateConversationRequest
   */
  estateId: number;
  /**
   *
   * @type {Set<number>}
   * @memberof UpdateConversationRequest
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof UpdateConversationRequest
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateConversationRequest
   */
  body?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdateConversationRequest
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {ServiceType}
   * @memberof UpdateConversationRequest
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {boolean}
   * @memberof UpdateConversationRequest
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateConversationRequest
   */
  publishingMode?: UpdateConversationRequestPublishingModeEnum;
}

export const UpdateConversationRequestPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type UpdateConversationRequestPublishingModeEnum =
  (typeof UpdateConversationRequestPublishingModeEnum)[keyof typeof UpdateConversationRequestPublishingModeEnum];

/**
 *
 * @export
 * @interface UpdateDocumentCategoryRequest
 */
export interface UpdateDocumentCategoryRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateDocumentCategoryRequest
   */
  name?: string;
}
/**
 *
 * @export
 * @interface UpdateDocumentRequest
 */
export interface UpdateDocumentRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateDocumentRequest
   */
  estateId: number;
  /**
   *
   * @type {string}
   * @memberof UpdateDocumentRequest
   */
  title?: string;
  /**
   *
   * @type {DocumentCategory}
   * @memberof UpdateDocumentRequest
   */
  category: DocumentCategory;
  /**
   *
   * @type {boolean}
   * @memberof UpdateDocumentRequest
   */
  published?: boolean;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateDocumentRequest
   */
  accessibleByTypes?: Array<UpdateDocumentRequestAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof UpdateDocumentRequest
   */
  accessibleByPersonIds?: Set<number>;
}

export const UpdateDocumentRequestAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type UpdateDocumentRequestAccessibleByTypesEnum =
  (typeof UpdateDocumentRequestAccessibleByTypesEnum)[keyof typeof UpdateDocumentRequestAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface UpdateEstateImageRequest
 */
export interface UpdateEstateImageRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateEstateImageRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateEstateImageRequest
   */
  mimeType?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateEstateImageRequest
   */
  contentBase64?: string;
}
/**
 *
 * @export
 * @interface UpdateEstateRequest
 */
export interface UpdateEstateRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateEstateRequest
   */
  name?: string;
  /**
   *
   * @type {Address}
   * @memberof UpdateEstateRequest
   */
  address?: Address;
  /**
   *
   * @type {Array<Update>}
   * @memberof UpdateEstateRequest
   */
  livingUnits?: Array<Update>;
  /**
   *
   * @type {Array<ServiceType>}
   * @memberof UpdateEstateRequest
   */
  serviceTypes?: Array<ServiceType>;
  /**
   *
   * @type {Array<DocumentCategory>}
   * @memberof UpdateEstateRequest
   */
  documentCategories?: Array<DocumentCategory>;
  /**
   *
   * @type {Create}
   * @memberof UpdateEstateRequest
   */
  image?: Create;
  /**
   *
   * @type {string}
   * @memberof UpdateEstateRequest
   */
  infoText?: string;
}
/**
 *
 * @export
 * @interface UpdateFromPerson
 */
export interface UpdateFromPerson {
  /**
   *
   * @type {number}
   * @memberof UpdateFromPerson
   */
  id?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateFromPerson
   */
  types?: Array<UpdateFromPersonTypesEnum>;
  /**
   *
   * @type {number}
   * @memberof UpdateFromPerson
   */
  estateId: number;
  /**
   *
   * @type {number}
   * @memberof UpdateFromPerson
   */
  livingUnitId?: number;
}

export const UpdateFromPersonTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type UpdateFromPersonTypesEnum =
  (typeof UpdateFromPersonTypesEnum)[keyof typeof UpdateFromPersonTypesEnum];

/**
 *
 * @export
 * @interface UpdateLivingUnitRequest
 */
export interface UpdateLivingUnitRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateLivingUnitRequest
   */
  id?: number;
  /**
   *
   * @type {string}
   * @memberof UpdateLivingUnitRequest
   */
  name?: string;
}
/**
 *
 * @export
 * @interface UpdatePasswordRequest
 */
export interface UpdatePasswordRequest {
  /**
   *
   * @type {string}
   * @memberof UpdatePasswordRequest
   */
  currentPassword?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePasswordRequest
   */
  newPassword?: string;
}
/**
 *
 * @export
 * @interface UpdatePersonEntityRelationRequest
 */
export interface UpdatePersonEntityRelationRequest {
  /**
   *
   * @type {number}
   * @memberof UpdatePersonEntityRelationRequest
   */
  id?: number;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdatePersonEntityRelationRequest
   */
  types?: Array<UpdatePersonEntityRelationRequestTypesEnum>;
  /**
   *
   * @type {number}
   * @memberof UpdatePersonEntityRelationRequest
   */
  estateId: number;
  /**
   *
   * @type {number}
   * @memberof UpdatePersonEntityRelationRequest
   */
  livingUnitId?: number;
}

export const UpdatePersonEntityRelationRequestTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type UpdatePersonEntityRelationRequestTypesEnum =
  (typeof UpdatePersonEntityRelationRequestTypesEnum)[keyof typeof UpdatePersonEntityRelationRequestTypesEnum];

/**
 *
 * @export
 * @interface UpdatePersonRequest
 */
export interface UpdatePersonRequest {
  /**
   *
   * @type {string}
   * @memberof UpdatePersonRequest
   */
  title?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePersonRequest
   */
  firstName?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePersonRequest
   */
  lastName?: string;
  /**
   *
   * @type {Address}
   * @memberof UpdatePersonRequest
   */
  address?: Address;
  /**
   *
   * @type {Array<PhoneNumber>}
   * @memberof UpdatePersonRequest
   */
  phoneNumbers?: Array<PhoneNumber>;
  /**
   *
   * @type {string}
   * @memberof UpdatePersonRequest
   */
  taxId?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePersonRequest
   */
  company?: string;
  /**
   *
   * @type {Array<EmailField>}
   * @memberof UpdatePersonRequest
   */
  emailAddresses?: Array<EmailField>;
  /**
   *
   * @type {Array<number>}
   * @memberof UpdatePersonRequest
   */
  filteredServiceTypeIds?: Array<number>;
  /**
   *
   * @type {boolean}
   * @memberof UpdatePersonRequest
   */
  resendInvitation?: boolean;
}
/**
 *
 * @export
 * @interface UpdatePostingRequest
 */
export interface UpdatePostingRequest {
  /**
   *
   * @type {number}
   * @memberof UpdatePostingRequest
   */
  estateId: number;
  /**
   *
   * @type {Set<number>}
   * @memberof UpdatePostingRequest
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof UpdatePostingRequest
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePostingRequest
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePostingRequest
   */
  publishFrom?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePostingRequest
   */
  publishTo?: string;
  /**
   *
   * @type {boolean}
   * @memberof UpdatePostingRequest
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdatePostingRequest
   */
  publishingMode?: UpdatePostingRequestPublishingModeEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdatePostingRequest
   */
  accessibleByTypes?: Array<UpdatePostingRequestAccessibleByTypesEnum>;
}

export const UpdatePostingRequestPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type UpdatePostingRequestPublishingModeEnum =
  (typeof UpdatePostingRequestPublishingModeEnum)[keyof typeof UpdatePostingRequestPublishingModeEnum];
export const UpdatePostingRequestAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type UpdatePostingRequestAccessibleByTypesEnum =
  (typeof UpdatePostingRequestAccessibleByTypesEnum)[keyof typeof UpdatePostingRequestAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface UpdatePropertyManagementRequest
 */
export interface UpdatePropertyManagementRequest {
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  emailAddress?: string;
  /**
   *
   * @type {Address}
   * @memberof UpdatePropertyManagementRequest
   */
  address?: Address;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  customColorPrimary?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext1?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext2?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext3?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext4?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext5?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext6?: string;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  freetext7?: string;
  /**
   *
   * @type {Create}
   * @memberof UpdatePropertyManagementRequest
   */
  logo?: Create;
  /**
   *
   * @type {InvitationCustomization}
   * @memberof UpdatePropertyManagementRequest
   */
  invitationCustomization?: InvitationCustomization;
  /**
   *
   * @type {PaymentSettings}
   * @memberof UpdatePropertyManagementRequest
   */
  paymentSettings?: PaymentSettings;
  /**
   *
   * @type {string}
   * @memberof UpdatePropertyManagementRequest
   */
  phoneNumber?: string;
}
/**
 *
 * @export
 * @interface UpdateServiceTypeRequest
 */
export interface UpdateServiceTypeRequest {
  /**
   *
   * @type {string}
   * @memberof UpdateServiceTypeRequest
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateServiceTypeRequest
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateServiceTypeRequest
   */
  iconName?: string;
}
/**
 *
 * @export
 * @interface UpdateTicketRequest
 */
export interface UpdateTicketRequest {
  /**
   *
   * @type {number}
   * @memberof UpdateTicketRequest
   */
  estateId: number;
  /**
   *
   * @type {Set<number>}
   * @memberof UpdateTicketRequest
   */
  livingUnitIds?: Set<number>;
  /**
   *
   * @type {string}
   * @memberof UpdateTicketRequest
   */
  subject?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTicketRequest
   */
  body?: string;
  /**
   *
   * @type {string}
   * @memberof UpdateTicketRequest
   */
  internalNotes?: string;
  /**
   *
   * @type {Set<number>}
   * @memberof UpdateTicketRequest
   */
  assigneeIds?: Set<number>;
  /**
   *
   * @type {boolean}
   * @memberof UpdateTicketRequest
   */
  messagesEnabled?: boolean;
  /**
   *
   * @type {ServiceType}
   * @memberof UpdateTicketRequest
   */
  serviceType?: ServiceType;
  /**
   *
   * @type {boolean}
   * @memberof UpdateTicketRequest
   */
  attachmentsEnabled?: boolean;
  /**
   *
   * @type {string}
   * @memberof UpdateTicketRequest
   */
  publishingMode?: UpdateTicketRequestPublishingModeEnum;
  /**
   *
   * @type {string}
   * @memberof UpdateTicketRequest
   */
  processingState?: UpdateTicketRequestProcessingStateEnum;
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateTicketRequest
   */
  accessibleByTypes?: Array<UpdateTicketRequestAccessibleByTypesEnum>;
  /**
   *
   * @type {Set<number>}
   * @memberof UpdateTicketRequest
   */
  accessibleByPersonIds?: Set<number>;
}

export const UpdateTicketRequestPublishingModeEnum = {
  Published: "PUBLISHED",
  Auto: "AUTO",
  Unpublished: "UNPUBLISHED",
} as const;

export type UpdateTicketRequestPublishingModeEnum =
  (typeof UpdateTicketRequestPublishingModeEnum)[keyof typeof UpdateTicketRequestPublishingModeEnum];
export const UpdateTicketRequestProcessingStateEnum = {
  New: "NEW",
  InProgress: "IN_PROGRESS",
  WorkDone: "WORK_DONE",
  Solved: "SOLVED",
} as const;

export type UpdateTicketRequestProcessingStateEnum =
  (typeof UpdateTicketRequestProcessingStateEnum)[keyof typeof UpdateTicketRequestProcessingStateEnum];
export const UpdateTicketRequestAccessibleByTypesEnum = {
  Owner: "OWNER",
  Tenant: "TENANT",
  Staff: "STAFF",
  Contractor: "CONTRACTOR",
  StaffPrimary: "STAFF_PRIMARY",
  Counselor: "COUNSELOR",
  ExternalContact: "EXTERNAL_CONTACT",
  TicketManager: "TICKET_MANAGER",
} as const;

export type UpdateTicketRequestAccessibleByTypesEnum =
  (typeof UpdateTicketRequestAccessibleByTypesEnum)[keyof typeof UpdateTicketRequestAccessibleByTypesEnum];

/**
 *
 * @export
 * @interface User
 */
export interface User {
  /**
   *
   * @type {number}
   * @memberof User
   */
  accountId?: number;
  /**
   *
   * @type {string}
   * @memberof User
   */
  emailAddress?: string;
  /**
   *
   * @type {boolean}
   * @memberof User
   */
  admin?: boolean;
  /**
   *
   * @type {Set<string>}
   * @memberof User
   */
  roles?: Set<string>;
}
/**
 *
 * @export
 * @interface VerifyPropertyManagementRegistrationRequest
 */
export interface VerifyPropertyManagementRegistrationRequest {
  /**
   *
   * @type {string}
   * @memberof VerifyPropertyManagementRegistrationRequest
   */
  token?: string;
}

/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = (configuration?: Configuration) => ({
  /**
   *
   * @summary Delete PropertyManagement
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  _delete: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("_delete", "id", id);
    const localVarPath = `/propertymanagements/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Accept Invitation
   * @param {AcceptInvitationRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  acceptInvitation: async (
    body?: AcceptInvitationRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/accounts/_acceptInvitation`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Begin Password Reset
   * @param {BeginPasswordResetRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  beginPasswordReset: async (
    body?: BeginPasswordResetRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/accounts/_beginPasswordReset`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create PropertyManagement
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  create: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/propertymanagements`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Account
   * @param {CreateAccountRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createAccount: async (
    body?: CreateAccountRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/accounts`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Asset
   * @param {Create} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createAsset: async (
    body?: Create,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/assets`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Attachment of Communication
   * @param {string} id
   * @param {string} type
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createAttachment: async (
    id: string,
    type: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("createAttachment", "id", id);
    // verify required parameter 'type' is not null or undefined
    assertParamExists("createAttachment", "type", type);
    const localVarPath = `/communications/{type}/{id}/attachments`
      .replace(`{${"id"}}`, encodeURIComponent(String(id)))
      .replace(`{${"type"}}`, encodeURIComponent(String(type)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Attachment of Document
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createAttachment1: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("createAttachment1", "id", id);
    const localVarPath = `/documents/{id}/attachments`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Add document category
   * @param {CreateDocumentCategoryRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createCategory: async (
    body?: CreateDocumentCategoryRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/documents/_categories`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Add Message to Communication
   * @param {string} type
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createCommunicationMessage: async (
    type: string,
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'type' is not null or undefined
    assertParamExists("createCommunicationMessage", "type", type);
    // verify required parameter 'id' is not null or undefined
    assertParamExists("createCommunicationMessage", "id", id);
    const localVarPath = `/communications/{type}/{id}/messages`
      .replace(`{${"type"}}`, encodeURIComponent(String(type)))
      .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Conversations
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createConversations: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/communications/conversations`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Document
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createDocument: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/documents`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Estate
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createEstate: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/estates`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get LivingUnits of Estate
   * @param {string} estateId
   * @param {CreateLivingUnitRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createLivingUnit: async (
    estateId: string,
    body?: CreateLivingUnitRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("createLivingUnit", "estateId", estateId);
    const localVarPath = `/estates/{estateId}/livingUnits`.replace(
      `{${"estateId"}}`,
      encodeURIComponent(String(estateId)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Person
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createPerson: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/persons`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Add Relation from Person to Estate or LivingUnit
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createPersonEntityRelation: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("createPersonEntityRelation", "id", id);
    const localVarPath = `/persons/{id}/relations`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Posting
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createPosting: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/communications/postings`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create ServiceType
   * @param {UpdateServiceTypeRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createServiceType: async (
    body?: UpdateServiceTypeRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/servicetypes`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Session
   * @param {EmailAddressAndPassword} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createSession: async (
    body?: EmailAddressAndPassword,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/sessions`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Ticket
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  createTicket: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/communications/tickets`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Account
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteAccount: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteAccount", "id", id);
    const localVarPath = `/accounts/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Asset
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteAsset: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteAsset", "id", id);
    const localVarPath = `/assets/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Attachment of Communication
   * @param {string} communicationId
   * @param {string} type
   * @param {number} attachmentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteAttachment: async (
    communicationId: string,
    type: string,
    attachmentId: number,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'communicationId' is not null or undefined
    assertParamExists("deleteAttachment", "communicationId", communicationId);
    // verify required parameter 'type' is not null or undefined
    assertParamExists("deleteAttachment", "type", type);
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists("deleteAttachment", "attachmentId", attachmentId);
    const localVarPath =
      `/communications/{type}/{communicationId}/attachments/{attachmentId}`
        .replace(
          `{${"communicationId"}}`,
          encodeURIComponent(String(communicationId)),
        )
        .replace(`{${"type"}}`, encodeURIComponent(String(type)))
        .replace(
          `{${"attachmentId"}}`,
          encodeURIComponent(String(attachmentId)),
        );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Attachment of Document
   * @param {string} documentId
   * @param {number} attachmentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteAttachment1: async (
    documentId: string,
    attachmentId: number,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'documentId' is not null or undefined
    assertParamExists("deleteAttachment1", "documentId", documentId);
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists("deleteAttachment1", "attachmentId", attachmentId);
    const localVarPath = `/documents/{documentId}/attachments/{attachmentId}`
      .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
      .replace(`{${"attachmentId"}}`, encodeURIComponent(String(attachmentId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete document category
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteCategory: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteCategory", "id", id);
    const localVarPath = `/documents/_categories/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Conversation
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteConversation: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteConversation", "id", id);
    const localVarPath = `/communications/conversations/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Document
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteDocument: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteDocument", "id", id);
    const localVarPath = `/documents/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Estate and its LivingUnits
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteEstate: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteEstate", "id", id);
    const localVarPath = `/estates/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Estate image
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteEstateImage: async (
    estateId: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("deleteEstateImage", "estateId", estateId);
    const localVarPath = `/estates/{estateId}/image`.replace(
      `{${"estateId"}}`,
      encodeURIComponent(String(estateId)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete LivingUnit of Estate
   * @param {string} estateId
   * @param {number} livingUnitId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteLivingUnit: async (
    estateId: string,
    livingUnitId: number,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("deleteLivingUnit", "estateId", estateId);
    // verify required parameter 'livingUnitId' is not null or undefined
    assertParamExists("deleteLivingUnit", "livingUnitId", livingUnitId);
    const localVarPath = `/estates/{estateId}/livingUnits/{livingUnitId}`
      .replace(`{${"estateId"}}`, encodeURIComponent(String(estateId)))
      .replace(`{${"livingUnitId"}}`, encodeURIComponent(String(livingUnitId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete PropertyManagement Logo
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteLogo: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteLogo", "id", id);
    const localVarPath = `/propertymanagements/{id}/logo`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Message of Communication
   * @param {string} type
   * @param {string} communicationId
   * @param {number} messageId
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteMessage: async (
    type: string,
    communicationId: string,
    messageId: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'type' is not null or undefined
    assertParamExists("deleteMessage", "type", type);
    // verify required parameter 'communicationId' is not null or undefined
    assertParamExists("deleteMessage", "communicationId", communicationId);
    // verify required parameter 'messageId' is not null or undefined
    assertParamExists("deleteMessage", "messageId", messageId);
    const localVarPath =
      `/communications/{type}/{communicationId}/messages/{messageId}`
        .replace(`{${"type"}}`, encodeURIComponent(String(type)))
        .replace(
          `{${"communicationId"}}`,
          encodeURIComponent(String(communicationId)),
        )
        .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Person
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deletePerson: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deletePerson", "id", id);
    const localVarPath = `/persons/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Relation between Person and Estate and/or LivingUnit
   * @param {string} personId
   * @param {number} relationId
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deletePersonEntityRelation: async (
    personId: string,
    relationId: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'personId' is not null or undefined
    assertParamExists("deletePersonEntityRelation", "personId", personId);
    // verify required parameter 'relationId' is not null or undefined
    assertParamExists("deletePersonEntityRelation", "relationId", relationId);
    const localVarPath = `/persons/{personId}/relations/{relationId}`
      .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
      .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Posting
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deletePosting: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deletePosting", "id", id);
    const localVarPath = `/communications/postings/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete ServiceType
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteServiceType: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteServiceType", "id", id);
    const localVarPath = `/servicetypes/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Delete Ticket
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteTicket: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("deleteTicket", "id", id);
    const localVarPath = `/communications/tickets/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Destroy Session
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  destroySession: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/sessions/_self`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Destroy Session
   * @param {string} token
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   */
  destroySession1: async (
    token: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'token' is not null or undefined
    assertParamExists("destroySession1", "token", token);
    const localVarPath = `/sessions/{token}`.replace(
      `{${"token"}}`,
      encodeURIComponent(String(token)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "DELETE",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find Persons
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Persons being PropertyManager or related to Estates of the that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  find: async (
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/persons`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find PropertyManagements
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  find1: async (
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'sort' is not null or undefined
    assertParamExists("find1", "sort", sort);
    // verify required parameter 'range' is not null or undefined
    assertParamExists("find1", "range", range);
    const localVarPath = `/propertymanagements`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find Accounts
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  findAccounts: async (
    sort?: string,
    range?: string,
    filter?: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/accounts`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find PropertyManagements and aggregate for admin overview
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {boolean} [loadContacts]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  findAndAggregate: async (
    sort: string,
    range: string,
    filter?: string,
    loadContacts?: boolean,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'sort' is not null or undefined
    assertParamExists("findAndAggregate", "sort", sort);
    // verify required parameter 'range' is not null or undefined
    assertParamExists("findAndAggregate", "range", range);
    const localVarPath = `/propertymanagements/_aggregate`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    if (loadContacts !== undefined) {
      localVarQueryParameter.loadContacts = loadContacts;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find Conversations
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  findConversations: async (
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'sort' is not null or undefined
    assertParamExists("findConversations", "sort", sort);
    // verify required parameter 'range' is not null or undefined
    assertParamExists("findConversations", "range", range);
    const localVarPath = `/communications/conversations`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find Documents
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] if set, only Documents of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  findDocuments: async (
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/documents`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find Postings
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  findPostings: async (
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/communications/postings`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find Tickets
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  findTickets: async (
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'sort' is not null or undefined
    assertParamExists("findTickets", "sort", sort);
    // verify required parameter 'range' is not null or undefined
    assertParamExists("findTickets", "range", range);
    const localVarPath = `/communications/tickets`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Verify Password Reset
   * @param {FinishPasswordResetRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  finishPassworReset: async (
    body?: FinishPasswordResetRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/accounts/_finishPasswordReset`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get PropertyManagement
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  get: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("get", "id", id);
    const localVarPath = `/propertymanagements/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Account
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAccount: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAccount", "id", id);
    const localVarPath = `/accounts/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAccountLevels: async (
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/propertymanagements/_accountLevels`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAdvPdf: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAdvPdf", "id", id);
    const localVarPath = `/propertymanagements/{id}/adv.pdf`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get agb.pdf content
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAgbPdfContent: async (
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/resources/agb.pdf`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get agb.pdf info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAgbPdfInfo: async (
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/resources/agb`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get all document categories
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAllCategories: async (
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/documents/_categories`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Find ServiceTypes
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAllServiceTypes: async (
    sort?: string,
    range?: string,
    filter?: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/servicetypes`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {string} id
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAssetContent: async (
    id: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAssetContent", "id", id);
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getAssetContent", "extension", extension);
    const localVarPath = `/assets/{id}.{extension}`
      .replace(`{${"id"}}`, encodeURIComponent(String(id)))
      .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (preview !== undefined) {
      localVarQueryParameter.preview = preview;
    }

    if (scalePercent !== undefined) {
      localVarQueryParameter.scalePercent = scalePercent;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Asset Info
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAssetInfo: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAssetInfo", "id", id);
    const localVarPath = `/assets/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get assignable property managers and ticket managers of the estate
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAssignablePropertyManagersOfEstate: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAssignablePropertyManagersOfEstate", "id", id);
    const localVarPath = `/estates/{id}/propertymanagers`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get assignable property managers and ticket managers of the estate. This is a lighter version of the /propertymanagers endpoint: It is less restrictive but does not include the managers\' full names.
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAssigneeInitials: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAssigneeInitials", "id", id);
    const localVarPath = `/estates/{id}/assignees`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {string} type
   * @param {string} communicationId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {string} [sig]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAttachmentContent: async (
    type: string,
    communicationId: string,
    attachmentId: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    sig?: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'type' is not null or undefined
    assertParamExists("getAttachmentContent", "type", type);
    // verify required parameter 'communicationId' is not null or undefined
    assertParamExists(
      "getAttachmentContent",
      "communicationId",
      communicationId,
    );
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists("getAttachmentContent", "attachmentId", attachmentId);
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getAttachmentContent", "extension", extension);
    const localVarPath =
      `/communications/{type}/{communicationId}/attachments/{attachmentId}.{extension}`
        .replace(`{${"type"}}`, encodeURIComponent(String(type)))
        .replace(
          `{${"communicationId"}}`,
          encodeURIComponent(String(communicationId)),
        )
        .replace(
          `{${"attachmentId"}}`,
          encodeURIComponent(String(attachmentId)),
        )
        .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (preview !== undefined) {
      localVarQueryParameter.preview = preview;
    }

    if (scalePercent !== undefined) {
      localVarQueryParameter.scalePercent = scalePercent;
    }

    if (sig !== undefined) {
      localVarQueryParameter.sig = sig;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Attachment Content (Image, PDF or Text)
   * @param {string} documentId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {string} [sig]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAttachmentContent1: async (
    documentId: string,
    attachmentId: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    sig?: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'documentId' is not null or undefined
    assertParamExists("getAttachmentContent1", "documentId", documentId);
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists("getAttachmentContent1", "attachmentId", attachmentId);
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getAttachmentContent1", "extension", extension);
    const localVarPath =
      `/documents/{documentId}/attachments/{attachmentId}.{extension}`
        .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
        .replace(
          `{${"attachmentId"}}`,
          encodeURIComponent(String(attachmentId)),
        )
        .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (preview !== undefined) {
      localVarQueryParameter.preview = preview;
    }

    if (scalePercent !== undefined) {
      localVarQueryParameter.scalePercent = scalePercent;
    }

    if (sig !== undefined) {
      localVarQueryParameter.sig = sig;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {string} id
   * @param {string} attachmentId
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAttachmentContent2: async (
    id: string,
    attachmentId: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getAttachmentContent2", "id", id);
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists("getAttachmentContent2", "attachmentId", attachmentId);
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getAttachmentContent2", "extension", extension);
    const localVarPath =
      `/propertymanagements/{id}/attachments/{attachmentId}.{extension}`
        .replace(`{${"id"}}`, encodeURIComponent(String(id)))
        .replace(
          `{${"attachmentId"}}`,
          encodeURIComponent(String(attachmentId)),
        )
        .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (preview !== undefined) {
      localVarQueryParameter.preview = preview;
    }

    if (scalePercent !== undefined) {
      localVarQueryParameter.scalePercent = scalePercent;
    }

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {string} type
   * @param {string} communicationId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAttachmentContentSignature: async (
    type: string,
    communicationId: string,
    attachmentId: string,
    extension: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'type' is not null or undefined
    assertParamExists("getAttachmentContentSignature", "type", type);
    // verify required parameter 'communicationId' is not null or undefined
    assertParamExists(
      "getAttachmentContentSignature",
      "communicationId",
      communicationId,
    );
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists(
      "getAttachmentContentSignature",
      "attachmentId",
      attachmentId,
    );
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getAttachmentContentSignature", "extension", extension);
    const localVarPath =
      `/communications/{type}/{communicationId}/attachments/_signature/{attachmentId}.{extension}`
        .replace(`{${"type"}}`, encodeURIComponent(String(type)))
        .replace(
          `{${"communicationId"}}`,
          encodeURIComponent(String(communicationId)),
        )
        .replace(
          `{${"attachmentId"}}`,
          encodeURIComponent(String(attachmentId)),
        )
        .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Signature for Attachment Content URL (Image, PDF or Text)
   * @param {string} documentId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getAttachmentContentSignature1: async (
    documentId: string,
    attachmentId: string,
    extension: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'documentId' is not null or undefined
    assertParamExists(
      "getAttachmentContentSignature1",
      "documentId",
      documentId,
    );
    // verify required parameter 'attachmentId' is not null or undefined
    assertParamExists(
      "getAttachmentContentSignature1",
      "attachmentId",
      attachmentId,
    );
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getAttachmentContentSignature1", "extension", extension);
    const localVarPath =
      `/documents/{documentId}/attachments/_signature/{attachmentId}.{extension}`
        .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)))
        .replace(
          `{${"attachmentId"}}`,
          encodeURIComponent(String(attachmentId)),
        )
        .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get document category
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getCategory: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getCategory", "id", id);
    const localVarPath = `/documents/_categories/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Conversations
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getConversation: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getConversation", "id", id);
    const localVarPath = `/communications/conversations/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Document
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getDocument: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getDocument", "id", id);
    const localVarPath = `/documents/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Estate by id
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getEstate: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getEstate", "id", id);
    const localVarPath = `/estates/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Contacts of Estate
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getEstateContacts: async (
    estateId: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("getEstateContacts", "estateId", estateId);
    const localVarPath = `/estates/{estateId}/contacts`.replace(
      `{${"estateId"}}`,
      encodeURIComponent(String(estateId)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {string} estateId
   * @param {string} assetId
   * @param {string} extension
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getEstateImageContent: async (
    estateId: string,
    assetId: string,
    extension: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("getEstateImageContent", "estateId", estateId);
    // verify required parameter 'assetId' is not null or undefined
    assertParamExists("getEstateImageContent", "assetId", assetId);
    // verify required parameter 'extension' is not null or undefined
    assertParamExists("getEstateImageContent", "extension", extension);
    const localVarPath = `/estates/{estateId}/{assetId}.{extension}`
      .replace(`{${"estateId"}}`, encodeURIComponent(String(estateId)))
      .replace(`{${"assetId"}}`, encodeURIComponent(String(assetId)))
      .replace(`{${"extension"}}`, encodeURIComponent(String(extension)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Estate image info
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getEstateImageInfo: async (
    estateId: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("getEstateImageInfo", "estateId", estateId);
    const localVarPath = `/estates/{estateId}/image`.replace(
      `{${"estateId"}}`,
      encodeURIComponent(String(estateId)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Search Estates
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getEstates: async (
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/estates`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get LivingUnit of Estate
   * @param {string} estateId
   * @param {number} livingUnitId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getLivingUnit: async (
    estateId: string,
    livingUnitId: number,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("getLivingUnit", "estateId", estateId);
    // verify required parameter 'livingUnitId' is not null or undefined
    assertParamExists("getLivingUnit", "livingUnitId", livingUnitId);
    const localVarPath = `/estates/{estateId}/livingUnits/{livingUnitId}`
      .replace(`{${"estateId"}}`, encodeURIComponent(String(estateId)))
      .replace(`{${"livingUnitId"}}`, encodeURIComponent(String(livingUnitId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get all LivingUnits of Estate
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getLivingUnits: async (
    estateId: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("getLivingUnits", "estateId", estateId);
    const localVarPath = `/estates/{estateId}/livingUnits`.replace(
      `{${"estateId"}}`,
      encodeURIComponent(String(estateId)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Messages of Communication
   * @param {string} type
   * @param {string} id
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getMessages: async (
    type: string,
    id: string,
    sort?: string,
    range?: string,
    filter?: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'type' is not null or undefined
    assertParamExists("getMessages", "type", type);
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getMessages", "id", id);
    const localVarPath = `/communications/{type}/{id}/messages`
      .replace(`{${"type"}}`, encodeURIComponent(String(type)))
      .replace(`{${"id"}}`, encodeURIComponent(String(id)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Person
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getPerson: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getPerson", "id", id);
    const localVarPath = `/persons/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Relations from Person to Estates or LivingUnits
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getPersonEntityRelations: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getPersonEntityRelations", "id", id);
    const localVarPath = `/persons/{id}/relations`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Posting
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getPosting: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getPosting", "id", id);
    const localVarPath = `/communications/postings/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get ServiceType
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getServiceType: async (
    id: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getServiceType", "id", id);
    const localVarPath = `/servicetypes/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Session
   * @param {string} token
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getSession: async (
    token: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'token' is not null or undefined
    assertParamExists("getSession", "token", token);
    const localVarPath = `/sessions/{token}`.replace(
      `{${"token"}}`,
      encodeURIComponent(String(token)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Get Ticket
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getTicket: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("getTicket", "id", id);
    const localVarPath = `/communications/tickets/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Ticket Board overview data
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getTicketOverview: async (
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'sort' is not null or undefined
    assertParamExists("getTicketOverview", "sort", sort);
    // verify required parameter 'range' is not null or undefined
    assertParamExists("getTicketOverview", "range", range);
    const localVarPath = `/communications/ticketOverview`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "GET",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    if (sort !== undefined) {
      localVarQueryParameter.sort = sort;
    }

    if (range !== undefined) {
      localVarQueryParameter.range = range;
    }

    if (filter !== undefined) {
      localVarQueryParameter.filter = filter;
    }

    localVarHeaderParameter["Content-Type"] = "application/json";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @param {number} [xPROPERTYMANAGEMENTID]
   * @param {File} [uploadFile]
   * @param {string} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  importXls: async (
    xPROPERTYMANAGEMENTID?: number,
    uploadFile?: File,
    type?: string,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/importer/_import`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;
    const localVarFormParams = new (configuration?.formDataCtor || FormData)();

    if (uploadFile !== undefined) {
      localVarFormParams.append("uploadFile", uploadFile as any);
    }

    if (type !== undefined) {
      localVarFormParams.append("type", type as any);
    }

    localVarHeaderParameter["Content-Type"] = "multipart/form-data";

    if (xPROPERTYMANAGEMENTID != null) {
      localVarHeaderParameter["X-PROPERTYMANAGEMENT-ID"] =
        typeof xPROPERTYMANAGEMENTID === "string"
          ? xPROPERTYMANAGEMENTID
          : JSON.stringify(xPROPERTYMANAGEMENTID);
    }
    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = localVarFormParams;

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Invite Person
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  invitePerson: async (
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/accounts/_invitePerson`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   * If the email address is already in use by an account, a login reminder email will be sent and a 409 will be returned. If the email address is already taken by a person invitation a 409 will be returned. If the email address is already taken by a PropertyManagementRegistration (not a PropertyManagement), the registration will be overwritten and a 200 will be returned.
   * @summary Begin PropertyManagement Registration
   * @param {RegisterPropertyManagementRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  register: async (
    body?: RegisterPropertyManagementRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/propertymanagements/_beginRegistration`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update PropertyManagement
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  update: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("update", "id", id);
    const localVarPath = `/propertymanagements/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Account
   * @param {string} id
   * @param {UpdateAccountRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAccount: async (
    id: string,
    body?: UpdateAccountRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateAccount", "id", id);
    const localVarPath = `/accounts/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Account Password
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAccountPassword: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateAccountPassword", "id", id);
    const localVarPath = `/accounts/{id}/_updatePassword`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update AGB PDF
   * @param {Create} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAgbPdf: async (
    body?: Create,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/resources/agb`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Updates assigned estates a of Account
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAssignedEstates: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateAssignedEstates", "id", id);
    const localVarPath = `/accounts/{id}/assignedEstates`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Create Attachment of Communication
   * @param {string} id
   * @param {string} type
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAttachments: async (
    id: string,
    type: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateAttachments", "id", id);
    // verify required parameter 'type' is not null or undefined
    assertParamExists("updateAttachments", "type", type);
    const localVarPath = `/communications/{type}/{id}/attachments`
      .replace(`{${"id"}}`, encodeURIComponent(String(id)))
      .replace(`{${"type"}}`, encodeURIComponent(String(type)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Attachments of Document
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateAttachments1: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateAttachments1", "id", id);
    const localVarPath = `/documents/{id}/attachments`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update document category
   * @param {string} id
   * @param {UpdateDocumentCategoryRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateCategory: async (
    id: string,
    body?: UpdateDocumentCategoryRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateCategory", "id", id);
    const localVarPath = `/documents/_categories/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Conversations
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateConversations: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateConversations", "id", id);
    const localVarPath = `/communications/conversations/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Document
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateDocument: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateDocument", "id", id);
    const localVarPath = `/documents/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Estate
   * @param {string} id
   * @param {UpdateEstateRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateEstate: async (
    id: string,
    body?: UpdateEstateRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateEstate", "id", id);
    const localVarPath = `/estates/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Estate image
   * @param {string} estateId
   * @param {UpdateEstateImageRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateEstateImage: async (
    estateId: string,
    body?: UpdateEstateImageRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("updateEstateImage", "estateId", estateId);
    const localVarPath = `/estates/{estateId}/image`.replace(
      `{${"estateId"}}`,
      encodeURIComponent(String(estateId)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update LivingUnit of Estate
   * @param {string} estateId
   * @param {number} livingUnitId
   * @param {UpdateLivingUnitRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateLivingUnit: async (
    estateId: string,
    livingUnitId: number,
    body?: UpdateLivingUnitRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'estateId' is not null or undefined
    assertParamExists("updateLivingUnit", "estateId", estateId);
    // verify required parameter 'livingUnitId' is not null or undefined
    assertParamExists("updateLivingUnit", "livingUnitId", livingUnitId);
    const localVarPath = `/estates/{estateId}/livingUnits/{livingUnitId}`
      .replace(`{${"estateId"}}`, encodeURIComponent(String(estateId)))
      .replace(`{${"livingUnitId"}}`, encodeURIComponent(String(livingUnitId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update PropertyManagement Logo
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateLogo: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateLogo", "id", id);
    const localVarPath = `/propertymanagements/{id}/logo`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update NotificationSettings of Account
   * @param {string} id
   * @param {NotificationSettings} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateNotificationSettings: async (
    id: string,
    body?: NotificationSettings,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateNotificationSettings", "id", id);
    const localVarPath = `/accounts/{id}/notificationSettings`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update all Relations from Person to Estate or LivingUnit
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updatePersionEntityRelations: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updatePersionEntityRelations", "id", id);
    const localVarPath = `/persons/{id}/relations`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Person
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updatePerson: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updatePerson", "id", id);
    const localVarPath = `/persons/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Relation of Person to Estate or LivingUnit
   * @param {string} personId
   * @param {number} relationId
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updatePersonEntityRelation: async (
    personId: string,
    relationId: number,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'personId' is not null or undefined
    assertParamExists("updatePersonEntityRelation", "personId", personId);
    // verify required parameter 'relationId' is not null or undefined
    assertParamExists("updatePersonEntityRelation", "relationId", relationId);
    const localVarPath = `/persons/{personId}/relations/{relationId}`
      .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
      .replace(`{${"relationId"}}`, encodeURIComponent(String(relationId)));
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Posting
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updatePosting: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updatePosting", "id", id);
    const localVarPath = `/communications/postings/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update ServiceType
   * @param {string} id
   * @param {UpdateServiceTypeRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateServiceType: async (
    id: string,
    body?: UpdateServiceTypeRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateServiceType", "id", id);
    const localVarPath = `/servicetypes/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Update Ticket
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  updateTicket: async (
    id: string,
    body?: Session,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    // verify required parameter 'id' is not null or undefined
    assertParamExists("updateTicket", "id", id);
    const localVarPath = `/communications/tickets/{id}`.replace(
      `{${"id"}}`,
      encodeURIComponent(String(id)),
    );
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "PUT",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
  /**
   *
   * @summary Finish PropertyManagement Registration
   * @param {VerifyPropertyManagementRegistrationRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  verify: async (
    body?: VerifyPropertyManagementRegistrationRequest,
    options: RawAxiosRequestConfig = {},
  ): Promise<RequestArgs> => {
    const localVarPath = `/propertymanagements/_verifyRegistration`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
      baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = {
      method: "POST",
      ...baseOptions,
      ...options,
    };
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    localVarHeaderParameter["Content-Type"] = "application/json";

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    const headersFromBaseOptions = baseOptions?.headers
      ? baseOptions.headers
      : {};
    localVarRequestOptions.headers = {
      ...localVarHeaderParameter,
      ...headersFromBaseOptions,
      ...options.headers,
    };
    localVarRequestOptions.data = serializeDataIfNeeded(
      body,
      localVarRequestOptions,
      configuration,
    );

    return {
      url: toPathString(localVarUrlObj),
      options: localVarRequestOptions,
    };
  },
});

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = (configuration?: Configuration) => {
  const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Delete PropertyManagement
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async _delete(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator._delete(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi._delete"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Accept Invitation
     * @param {AcceptInvitationRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async acceptInvitation(
      body?: AcceptInvitationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.acceptInvitation(body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.acceptInvitation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Begin Password Reset
     * @param {BeginPasswordResetRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async beginPasswordReset(
      body?: BeginPasswordResetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.beginPasswordReset(body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.beginPasswordReset"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create PropertyManagement
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async create(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertyManagement>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.create(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.create"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Account
     * @param {CreateAccountRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAccount(
      body?: CreateAccountRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createAccount(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createAccount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Asset
     * @param {Create} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAsset(
      body?: Create,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Asset>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createAsset(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createAsset"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Attachment of Communication
     * @param {string} id
     * @param {string} type
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAttachment(
      id: string,
      type: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<CommunicationAttachment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createAttachment(
          id,
          type,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createAttachment"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Attachment of Document
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createAttachment1(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DocumentAttachment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createAttachment1(id, body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createAttachment1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Add document category
     * @param {CreateDocumentCategoryRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCategory(
      body?: CreateDocumentCategoryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DocumentCategory>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createCategory(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createCategory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Add Message to Communication
     * @param {string} type
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createCommunicationMessage(
      type: string,
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Message>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createCommunicationMessage(
          type,
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createCommunicationMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Conversations
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createConversations(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Conversation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createConversations(body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createConversations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Document
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createDocument(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createDocument(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createDocument"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Estate
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createEstate(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Estate>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createEstate(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createEstate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get LivingUnits of Estate
     * @param {string} estateId
     * @param {CreateLivingUnitRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createLivingUnit(
      estateId: string,
      body?: CreateLivingUnitRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LivingUnit>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createLivingUnit(
          estateId,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createLivingUnit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Person
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPerson(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPerson(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createPerson"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Add Relation from Person to Estate or LivingUnit
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPersonEntityRelation(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PersonEntityRelation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createPersonEntityRelation(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createPersonEntityRelation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Posting
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createPosting(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Posting>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createPosting(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createPosting"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create ServiceType
     * @param {UpdateServiceTypeRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createServiceType(
      body?: UpdateServiceTypeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceType>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.createServiceType(body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createServiceType"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Session
     * @param {EmailAddressAndPassword} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createSession(
      body?: EmailAddressAndPassword,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createSession(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createSession"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Ticket
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async createTicket(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.createTicket(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.createTicket"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAccount(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAccount(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteAccount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAsset(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAsset(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteAsset"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Attachment of Communication
     * @param {string} communicationId
     * @param {string} type
     * @param {number} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAttachment(
      communicationId: string,
      type: string,
      attachmentId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteAttachment(
          communicationId,
          type,
          attachmentId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteAttachment"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Attachment of Document
     * @param {string} documentId
     * @param {number} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteAttachment1(
      documentId: string,
      attachmentId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteAttachment1(
          documentId,
          attachmentId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteAttachment1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete document category
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteCategory(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCategory(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteCategory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Conversation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteConversation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteConversation(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteConversation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Document
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocument(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteDocument"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Estate and its LivingUnits
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEstate(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEstate(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteEstate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Estate image
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteEstateImage(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteEstateImage(estateId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteEstateImage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete LivingUnit of Estate
     * @param {string} estateId
     * @param {number} livingUnitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteLivingUnit(
      estateId: string,
      livingUnitId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteLivingUnit(
          estateId,
          livingUnitId,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteLivingUnit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete PropertyManagement Logo
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteLogo(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLogo(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteLogo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Message of Communication
     * @param {string} type
     * @param {string} communicationId
     * @param {number} messageId
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteMessage(
      type: string,
      communicationId: string,
      messageId: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteMessage(
        type,
        communicationId,
        messageId,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteMessage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Person
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePerson(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deletePerson(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deletePerson"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Relation between Person and Estate and/or LivingUnit
     * @param {string} personId
     * @param {number} relationId
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePersonEntityRelation(
      personId: string,
      relationId: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deletePersonEntityRelation(
          personId,
          relationId,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deletePersonEntityRelation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Posting
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deletePosting(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deletePosting(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deletePosting"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete ServiceType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteServiceType(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.deleteServiceType(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteServiceType"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Delete Ticket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async deleteTicket(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTicket(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.deleteTicket"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Destroy Session
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async destroySession(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.destroySession(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.destroySession"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Destroy Session
     * @param {string} token
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    async destroySession1(
      token: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.destroySession1(
        token,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.destroySession1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find Persons
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Persons being PropertyManager or related to Estates of the that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async find(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Person>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.find(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.find"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find PropertyManagements
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async find1(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PropertyManagement>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.find1(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.find1"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find Accounts
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findAccounts(
      sort?: string,
      range?: string,
      filter?: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Account>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findAccounts(
        sort,
        range,
        filter,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.findAccounts"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find PropertyManagements and aggregate for admin overview
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {boolean} [loadContacts]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findAndAggregate(
      sort: string,
      range: string,
      filter?: string,
      loadContacts?: boolean,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PropertyManagement>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.findAndAggregate(
          sort,
          range,
          filter,
          loadContacts,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.findAndAggregate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find Conversations
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findConversations(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<Conversation>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.findConversations(
          sort,
          range,
          filter,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.findConversations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find Documents
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] if set, only Documents of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findDocuments(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<Document>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findDocuments(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.findDocuments"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find Postings
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findPostings(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Posting>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findPostings(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.findPostings"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find Tickets
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async findTickets(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Ticket>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.findTickets(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.findTickets"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Verify Password Reset
     * @param {FinishPasswordResetRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async finishPassworReset(
      body?: FinishPasswordResetRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<FinishPasswordResetResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.finishPassworReset(body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.finishPassworReset"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get PropertyManagement
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async get(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertyManagement>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.get(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.get"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Account
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccount(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAccount(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAccount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAccountLevels(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<AccountLevelConfig>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAccountLevels(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAccountLevels"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAdvPdf(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAdvPdf(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAdvPdf"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get agb.pdf content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAgbPdfContent(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAgbPdfContent(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAgbPdfContent"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get agb.pdf info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAgbPdfInfo(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Info>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAgbPdfInfo(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAgbPdfInfo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all document categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllCategories(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<DocumentCategory>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAllCategories(options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAllCategories"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Find ServiceTypes
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllServiceTypes(
      sort?: string,
      range?: string,
      filter?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchResultServiceType>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAllServiceTypes(
          sort,
          range,
          filter,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAllServiceTypes"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssetContent(
      id: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetContent(
        id,
        extension,
        preview,
        scalePercent,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAssetContent"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Asset Info
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssetInfo(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Info>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssetInfo(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAssetInfo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get assignable property managers and ticket managers of the estate
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssignablePropertyManagersOfEstate(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EstateManager>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAssignablePropertyManagersOfEstate(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap[
          "DefaultApi.getAssignablePropertyManagersOfEstate"
        ]?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get assignable property managers and ticket managers of the estate. This is a lighter version of the /propertymanagers endpoint: It is less restrictive but does not include the managers\' full names.
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssigneeInitials(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<EstateManager>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAssigneeInitials(id, body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAssigneeInitials"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} type
     * @param {string} communicationId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {string} [sig]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAttachmentContent(
      type: string,
      communicationId: string,
      attachmentId: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      sig?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAttachmentContent(
          type,
          communicationId,
          attachmentId,
          extension,
          preview,
          scalePercent,
          sig,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAttachmentContent"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Attachment Content (Image, PDF or Text)
     * @param {string} documentId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {string} [sig]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAttachmentContent1(
      documentId: string,
      attachmentId: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      sig?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAttachmentContent1(
          documentId,
          attachmentId,
          extension,
          preview,
          scalePercent,
          sig,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAttachmentContent1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} id
     * @param {string} attachmentId
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAttachmentContent2(
      id: string,
      attachmentId: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAttachmentContent2(
          id,
          attachmentId,
          extension,
          preview,
          scalePercent,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAttachmentContent2"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} type
     * @param {string} communicationId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAttachmentContentSignature(
      type: string,
      communicationId: string,
      attachmentId: string,
      extension: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetCommunicationAttachmentSignatureResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAttachmentContentSignature(
          type,
          communicationId,
          attachmentId,
          extension,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAttachmentContentSignature"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Signature for Attachment Content URL (Image, PDF or Text)
     * @param {string} documentId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAttachmentContentSignature1(
      documentId: string,
      attachmentId: string,
      extension: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<GetDocumentAttachmentSignatureResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAttachmentContentSignature1(
          documentId,
          attachmentId,
          extension,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getAttachmentContentSignature1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get document category
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getCategory(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DocumentCategory>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getCategory(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getCategory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Conversations
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getConversation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Conversation>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getConversation(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getConversation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Document
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getDocument(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getDocument"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Estate by id
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEstate(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Estate>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEstate(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEstate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Contacts of Estate
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEstateContacts(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchResultEstateContact>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEstateContacts(estateId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEstateContacts"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} estateId
     * @param {string} assetId
     * @param {string} extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEstateImageContent(
      estateId: string,
      assetId: string,
      extension: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEstateImageContent(
          estateId,
          assetId,
          extension,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEstateImageContent"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Estate image info
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEstateImageInfo(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Info>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getEstateImageInfo(estateId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEstateImageInfo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Search Estates
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getEstates(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Estate>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getEstates(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getEstates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get LivingUnit of Estate
     * @param {string} estateId
     * @param {number} livingUnitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLivingUnit(
      estateId: string,
      livingUnitId: number,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LivingUnit>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLivingUnit(
        estateId,
        livingUnitId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getLivingUnit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all LivingUnits of Estate
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getLivingUnits(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<LivingUnit>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getLivingUnits(
        estateId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getLivingUnits"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Messages of Communication
     * @param {string} type
     * @param {string} id
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getMessages(
      type: string,
      id: string,
      sort?: string,
      range?: string,
      filter?: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getMessages(
        type,
        id,
        sort,
        range,
        filter,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getMessages"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Person
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPerson(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPerson(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPerson"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Relations from Person to Estates or LivingUnits
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPersonEntityRelations(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<PersonEntityRelation>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getPersonEntityRelations(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPersonEntityRelations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Posting
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getPosting(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Posting>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getPosting(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getPosting"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get ServiceType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getServiceType(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceType>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getServiceType(
        id,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getServiceType"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Session
     * @param {string} token
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getSession(
      token: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Session>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getSession(
        token,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getSession"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get Ticket
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTicket(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getTicket(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getTicket"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Ticket Board overview data
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getTicketOverview(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<Array<TicketOverviewData>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getTicketOverview(
          sort,
          range,
          filter,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.getTicketOverview"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {number} [xPROPERTYMANAGEMENTID]
     * @param {File} [uploadFile]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async importXls(
      xPROPERTYMANAGEMENTID?: number,
      uploadFile?: File,
      type?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<ImportXlsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.importXls(
        xPROPERTYMANAGEMENTID,
        uploadFile,
        type,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.importXls"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Invite Person
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async invitePerson(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<InvitePersonResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.invitePerson(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.invitePerson"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * If the email address is already in use by an account, a login reminder email will be sent and a 409 will be returned. If the email address is already taken by a person invitation a 409 will be returned. If the email address is already taken by a PropertyManagementRegistration (not a PropertyManagement), the registration will be overwritten and a 200 will be returned.
     * @summary Begin PropertyManagement Registration
     * @param {RegisterPropertyManagementRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async register(
      body?: RegisterPropertyManagementRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.register(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.register"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update PropertyManagement
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async update(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertyManagement>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.update(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.update"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Account
     * @param {string} id
     * @param {UpdateAccountRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccount(
      id: string,
      body?: UpdateAccountRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Account>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAccount(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateAccount"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Account Password
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAccountPassword(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateAccountPassword(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateAccountPassword"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update AGB PDF
     * @param {Create} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAgbPdf(
      body?: Create,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Asset>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateAgbPdf(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateAgbPdf"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Updates assigned estates a of Account
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAssignedEstates(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Estate>>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateAssignedEstates(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateAssignedEstates"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Create Attachment of Communication
     * @param {string} id
     * @param {string} type
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAttachments(
      id: string,
      type: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchResultCommunicationAttachment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateAttachments(
          id,
          type,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateAttachments"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Attachments of Document
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateAttachments1(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchResultDocumentAttachment>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateAttachments1(id, body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateAttachments1"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update document category
     * @param {string} id
     * @param {UpdateDocumentCategoryRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateCategory(
      id: string,
      body?: UpdateDocumentCategoryRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<DocumentCategory>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateCategory(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateCategory"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Conversations
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateConversations(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Conversation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateConversations(id, body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateConversations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Document
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateDocument(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateDocument(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateDocument"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Estate
     * @param {string} id
     * @param {UpdateEstateRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEstate(
      id: string,
      body?: UpdateEstateRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Estate>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateEstate(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateEstate"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Estate image
     * @param {string} estateId
     * @param {UpdateEstateImageRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateEstateImage(
      estateId: string,
      body?: UpdateEstateImageRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Asset>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateEstateImage(
          estateId,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateEstateImage"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update LivingUnit of Estate
     * @param {string} estateId
     * @param {number} livingUnitId
     * @param {UpdateLivingUnitRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLivingUnit(
      estateId: string,
      livingUnitId: number,
      body?: UpdateLivingUnitRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LivingUnit>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateLivingUnit(
          estateId,
          livingUnitId,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateLivingUnit"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update PropertyManagement Logo
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateLogo(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertyManagementAttachment>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateLogo(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateLogo"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update NotificationSettings of Account
     * @param {string} id
     * @param {NotificationSettings} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateNotificationSettings(
      id: string,
      body?: NotificationSettings,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<NotificationSettings>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateNotificationSettings(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateNotificationSettings"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update all Relations from Person to Estate or LivingUnit
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePersionEntityRelations(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<SearchResultPersonEntityRelation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updatePersionEntityRelations(
          id,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updatePersionEntityRelations"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Person
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePerson(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Person>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePerson(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updatePerson"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Relation of Person to Estate or LivingUnit
     * @param {string} personId
     * @param {number} relationId
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePersonEntityRelation(
      personId: string,
      relationId: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PersonEntityRelation>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updatePersonEntityRelation(
          personId,
          relationId,
          body,
          options,
        );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updatePersonEntityRelation"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Posting
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updatePosting(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Posting>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updatePosting(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updatePosting"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update ServiceType
     * @param {string} id
     * @param {UpdateServiceTypeRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateServiceType(
      id: string,
      body?: UpdateServiceTypeRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceType>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.updateServiceType(id, body, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateServiceType"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Update Ticket
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateTicket(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Ticket>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateTicket(
        id,
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.updateTicket"]?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Finish PropertyManagement Registration
     * @param {VerifyPropertyManagementRegistrationRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async verify(
      body?: VerifyPropertyManagementRegistrationRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<PropertyManagement>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.verify(
        body,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap["DefaultApi.verify"]?.[localVarOperationServerIndex]
          ?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) => {
  const localVarFp = DefaultApiFp(configuration);
  return {
    /**
     *
     * @summary Delete PropertyManagement
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    _delete(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        ._delete(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Accept Invitation
     * @param {AcceptInvitationRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    acceptInvitation(
      body?: AcceptInvitationRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .acceptInvitation(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Begin Password Reset
     * @param {BeginPasswordResetRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    beginPasswordReset(
      body?: BeginPasswordResetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .beginPasswordReset(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create PropertyManagement
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    create(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PropertyManagement> {
      return localVarFp
        .create(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Account
     * @param {CreateAccountRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAccount(
      body?: CreateAccountRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Account> {
      return localVarFp
        .createAccount(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Asset
     * @param {Create} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAsset(
      body?: Create,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Asset> {
      return localVarFp
        .createAsset(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Attachment of Communication
     * @param {string} id
     * @param {string} type
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAttachment(
      id: string,
      type: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<CommunicationAttachment> {
      return localVarFp
        .createAttachment(id, type, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Attachment of Document
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createAttachment1(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DocumentAttachment> {
      return localVarFp
        .createAttachment1(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add document category
     * @param {CreateDocumentCategoryRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCategory(
      body?: CreateDocumentCategoryRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DocumentCategory> {
      return localVarFp
        .createCategory(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add Message to Communication
     * @param {string} type
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCommunicationMessage(
      type: string,
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Message> {
      return localVarFp
        .createCommunicationMessage(type, id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Conversations
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createConversations(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Conversation> {
      return localVarFp
        .createConversations(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Document
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createDocument(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Document> {
      return localVarFp
        .createDocument(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Estate
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createEstate(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Estate> {
      return localVarFp
        .createEstate(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get LivingUnits of Estate
     * @param {string} estateId
     * @param {CreateLivingUnitRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createLivingUnit(
      estateId: string,
      body?: CreateLivingUnitRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LivingUnit> {
      return localVarFp
        .createLivingUnit(estateId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Person
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPerson(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Person> {
      return localVarFp
        .createPerson(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Add Relation from Person to Estate or LivingUnit
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPersonEntityRelation(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonEntityRelation> {
      return localVarFp
        .createPersonEntityRelation(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Posting
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createPosting(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Posting> {
      return localVarFp
        .createPosting(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create ServiceType
     * @param {UpdateServiceTypeRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createServiceType(
      body?: UpdateServiceTypeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServiceType> {
      return localVarFp
        .createServiceType(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Session
     * @param {EmailAddressAndPassword} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createSession(
      body?: EmailAddressAndPassword,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Session> {
      return localVarFp
        .createSession(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Ticket
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createTicket(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Ticket> {
      return localVarFp
        .createTicket(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Account
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAccount(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteAccount(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Asset
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAsset(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteAsset(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Attachment of Communication
     * @param {string} communicationId
     * @param {string} type
     * @param {number} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAttachment(
      communicationId: string,
      type: string,
      attachmentId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteAttachment(communicationId, type, attachmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Attachment of Document
     * @param {string} documentId
     * @param {number} attachmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteAttachment1(
      documentId: string,
      attachmentId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteAttachment1(documentId, attachmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete document category
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteCategory(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteCategory(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Conversation
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteConversation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteConversation(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Document
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteDocument(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Estate and its LivingUnits
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEstate(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteEstate(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Estate image
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteEstateImage(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteEstateImage(estateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete LivingUnit of Estate
     * @param {string} estateId
     * @param {number} livingUnitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLivingUnit(
      estateId: string,
      livingUnitId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteLivingUnit(estateId, livingUnitId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete PropertyManagement Logo
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteLogo(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteLogo(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Message of Communication
     * @param {string} type
     * @param {string} communicationId
     * @param {number} messageId
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteMessage(
      type: string,
      communicationId: string,
      messageId: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteMessage(type, communicationId, messageId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Person
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePerson(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deletePerson(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Relation between Person and Estate and/or LivingUnit
     * @param {string} personId
     * @param {number} relationId
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePersonEntityRelation(
      personId: string,
      relationId: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deletePersonEntityRelation(personId, relationId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Posting
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deletePosting(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deletePosting(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete ServiceType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteServiceType(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteServiceType(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Delete Ticket
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteTicket(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .deleteTicket(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Destroy Session
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    destroySession(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .destroySession(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Destroy Session
     * @param {string} token
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    destroySession1(
      token: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .destroySession1(token, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find Persons
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Persons being PropertyManager or related to Estates of the that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    find(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Person>> {
      return localVarFp
        .find(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find PropertyManagements
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    find1(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PropertyManagement>> {
      return localVarFp
        .find1(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find Accounts
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findAccounts(
      sort?: string,
      range?: string,
      filter?: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Account>> {
      return localVarFp
        .findAccounts(sort, range, filter, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find PropertyManagements and aggregate for admin overview
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {boolean} [loadContacts]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findAndAggregate(
      sort: string,
      range: string,
      filter?: string,
      loadContacts?: boolean,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PropertyManagement>> {
      return localVarFp
        .findAndAggregate(
          sort,
          range,
          filter,
          loadContacts,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find Conversations
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findConversations(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Conversation>> {
      return localVarFp
        .findConversations(
          sort,
          range,
          filter,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find Documents
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] if set, only Documents of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findDocuments(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Document>> {
      return localVarFp
        .findDocuments(
          sort,
          range,
          filter,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find Postings
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findPostings(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Posting>> {
      return localVarFp
        .findPostings(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find Tickets
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    findTickets(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Ticket>> {
      return localVarFp
        .findTickets(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Verify Password Reset
     * @param {FinishPasswordResetRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    finishPassworReset(
      body?: FinishPasswordResetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<FinishPasswordResetResponse> {
      return localVarFp
        .finishPassworReset(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get PropertyManagement
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    get(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PropertyManagement> {
      return localVarFp
        .get(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Account
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccount(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Account> {
      return localVarFp
        .getAccount(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAccountLevels(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<AccountLevelConfig>> {
      return localVarFp
        .getAccountLevels(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAdvPdf(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .getAdvPdf(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get agb.pdf content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgbPdfContent(options?: RawAxiosRequestConfig): AxiosPromise<void> {
      return localVarFp
        .getAgbPdfContent(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get agb.pdf info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAgbPdfInfo(options?: RawAxiosRequestConfig): AxiosPromise<Info> {
      return localVarFp
        .getAgbPdfInfo(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all document categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllCategories(
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<DocumentCategory>> {
      return localVarFp
        .getAllCategories(options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Find ServiceTypes
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllServiceTypes(
      sort?: string,
      range?: string,
      filter?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SearchResultServiceType> {
      return localVarFp
        .getAllServiceTypes(sort, range, filter, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssetContent(
      id: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .getAssetContent(id, extension, preview, scalePercent, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Asset Info
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssetInfo(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Info> {
      return localVarFp
        .getAssetInfo(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get assignable property managers and ticket managers of the estate
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssignablePropertyManagersOfEstate(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EstateManager>> {
      return localVarFp
        .getAssignablePropertyManagersOfEstate(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get assignable property managers and ticket managers of the estate. This is a lighter version of the /propertymanagers endpoint: It is less restrictive but does not include the managers\' full names.
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssigneeInitials(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<EstateManager>> {
      return localVarFp
        .getAssigneeInitials(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} type
     * @param {string} communicationId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {string} [sig]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachmentContent(
      type: string,
      communicationId: string,
      attachmentId: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      sig?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .getAttachmentContent(
          type,
          communicationId,
          attachmentId,
          extension,
          preview,
          scalePercent,
          sig,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Attachment Content (Image, PDF or Text)
     * @param {string} documentId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {string} [sig]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachmentContent1(
      documentId: string,
      attachmentId: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      sig?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .getAttachmentContent1(
          documentId,
          attachmentId,
          extension,
          preview,
          scalePercent,
          sig,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} id
     * @param {string} attachmentId
     * @param {string} extension
     * @param {boolean} [preview]
     * @param {number} [scalePercent]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachmentContent2(
      id: string,
      attachmentId: string,
      extension: string,
      preview?: boolean,
      scalePercent?: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .getAttachmentContent2(
          id,
          attachmentId,
          extension,
          preview,
          scalePercent,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} type
     * @param {string} communicationId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachmentContentSignature(
      type: string,
      communicationId: string,
      attachmentId: string,
      extension: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetCommunicationAttachmentSignatureResponse> {
      return localVarFp
        .getAttachmentContentSignature(
          type,
          communicationId,
          attachmentId,
          extension,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Signature for Attachment Content URL (Image, PDF or Text)
     * @param {string} documentId
     * @param {string} attachmentId
     * @param {string} extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAttachmentContentSignature1(
      documentId: string,
      attachmentId: string,
      extension: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<GetDocumentAttachmentSignatureResponse> {
      return localVarFp
        .getAttachmentContentSignature1(
          documentId,
          attachmentId,
          extension,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get document category
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCategory(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DocumentCategory> {
      return localVarFp
        .getCategory(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Conversations
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getConversation(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Conversation> {
      return localVarFp
        .getConversation(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Document
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getDocument(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Document> {
      return localVarFp
        .getDocument(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Estate by id
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEstate(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Estate> {
      return localVarFp
        .getEstate(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Contacts of Estate
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEstateContacts(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SearchResultEstateContact> {
      return localVarFp
        .getEstateContacts(estateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {string} estateId
     * @param {string} assetId
     * @param {string} extension
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEstateImageContent(
      estateId: string,
      assetId: string,
      extension: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .getEstateImageContent(estateId, assetId, extension, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Estate image info
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEstateImageInfo(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Info> {
      return localVarFp
        .getEstateImageInfo(estateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Search Estates
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getEstates(
      sort?: string,
      range?: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Estate>> {
      return localVarFp
        .getEstates(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get LivingUnit of Estate
     * @param {string} estateId
     * @param {number} livingUnitId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLivingUnit(
      estateId: string,
      livingUnitId: number,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LivingUnit> {
      return localVarFp
        .getLivingUnit(estateId, livingUnitId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all LivingUnits of Estate
     * @param {string} estateId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getLivingUnits(
      estateId: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<LivingUnit>> {
      return localVarFp
        .getLivingUnits(estateId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Messages of Communication
     * @param {string} type
     * @param {string} id
     * @param {string} [sort]
     * @param {string} [range]
     * @param {string} [filter]
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getMessages(
      type: string,
      id: string,
      sort?: string,
      range?: string,
      filter?: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Message>> {
      return localVarFp
        .getMessages(type, id, sort, range, filter, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Person
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPerson(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Person> {
      return localVarFp
        .getPerson(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Relations from Person to Estates or LivingUnits
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPersonEntityRelations(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<PersonEntityRelation>> {
      return localVarFp
        .getPersonEntityRelations(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Posting
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getPosting(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Posting> {
      return localVarFp
        .getPosting(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get ServiceType
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getServiceType(
      id: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServiceType> {
      return localVarFp
        .getServiceType(id, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Session
     * @param {string} token
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getSession(
      token: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Session> {
      return localVarFp
        .getSession(token, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get Ticket
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTicket(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Ticket> {
      return localVarFp
        .getTicket(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Ticket Board overview data
     * @param {string} sort
     * @param {string} range
     * @param {string} [filter]
     * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getTicketOverview(
      sort: string,
      range: string,
      filter?: string,
      xPROPERTYMANAGEMENTID?: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<TicketOverviewData>> {
      return localVarFp
        .getTicketOverview(
          sort,
          range,
          filter,
          xPROPERTYMANAGEMENTID,
          body,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {number} [xPROPERTYMANAGEMENTID]
     * @param {File} [uploadFile]
     * @param {string} [type]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    importXls(
      xPROPERTYMANAGEMENTID?: number,
      uploadFile?: File,
      type?: string,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ImportXlsResponse> {
      return localVarFp
        .importXls(xPROPERTYMANAGEMENTID, uploadFile, type, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Invite Person
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    invitePerson(
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<InvitePersonResponse> {
      return localVarFp
        .invitePerson(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     * If the email address is already in use by an account, a login reminder email will be sent and a 409 will be returned. If the email address is already taken by a person invitation a 409 will be returned. If the email address is already taken by a PropertyManagementRegistration (not a PropertyManagement), the registration will be overwritten and a 200 will be returned.
     * @summary Begin PropertyManagement Registration
     * @param {RegisterPropertyManagementRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    register(
      body?: RegisterPropertyManagementRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .register(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update PropertyManagement
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    update(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PropertyManagement> {
      return localVarFp
        .update(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Account
     * @param {string} id
     * @param {UpdateAccountRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccount(
      id: string,
      body?: UpdateAccountRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Account> {
      return localVarFp
        .updateAccount(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Account Password
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAccountPassword(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .updateAccountPassword(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update AGB PDF
     * @param {Create} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAgbPdf(
      body?: Create,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Asset> {
      return localVarFp
        .updateAgbPdf(body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Updates assigned estates a of Account
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAssignedEstates(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Estate>> {
      return localVarFp
        .updateAssignedEstates(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Create Attachment of Communication
     * @param {string} id
     * @param {string} type
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAttachments(
      id: string,
      type: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SearchResultCommunicationAttachment> {
      return localVarFp
        .updateAttachments(id, type, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Attachments of Document
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateAttachments1(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SearchResultDocumentAttachment> {
      return localVarFp
        .updateAttachments1(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update document category
     * @param {string} id
     * @param {UpdateDocumentCategoryRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateCategory(
      id: string,
      body?: UpdateDocumentCategoryRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<DocumentCategory> {
      return localVarFp
        .updateCategory(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Conversations
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateConversations(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Conversation> {
      return localVarFp
        .updateConversations(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Document
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateDocument(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Document> {
      return localVarFp
        .updateDocument(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Estate
     * @param {string} id
     * @param {UpdateEstateRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEstate(
      id: string,
      body?: UpdateEstateRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Estate> {
      return localVarFp
        .updateEstate(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Estate image
     * @param {string} estateId
     * @param {UpdateEstateImageRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateEstateImage(
      estateId: string,
      body?: UpdateEstateImageRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Asset> {
      return localVarFp
        .updateEstateImage(estateId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update LivingUnit of Estate
     * @param {string} estateId
     * @param {number} livingUnitId
     * @param {UpdateLivingUnitRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLivingUnit(
      estateId: string,
      livingUnitId: number,
      body?: UpdateLivingUnitRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<LivingUnit> {
      return localVarFp
        .updateLivingUnit(estateId, livingUnitId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update PropertyManagement Logo
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateLogo(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PropertyManagementAttachment> {
      return localVarFp
        .updateLogo(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update NotificationSettings of Account
     * @param {string} id
     * @param {NotificationSettings} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateNotificationSettings(
      id: string,
      body?: NotificationSettings,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<NotificationSettings> {
      return localVarFp
        .updateNotificationSettings(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update all Relations from Person to Estate or LivingUnit
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersionEntityRelations(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<SearchResultPersonEntityRelation> {
      return localVarFp
        .updatePersionEntityRelations(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Person
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePerson(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Person> {
      return localVarFp
        .updatePerson(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Relation of Person to Estate or LivingUnit
     * @param {string} personId
     * @param {number} relationId
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePersonEntityRelation(
      personId: string,
      relationId: number,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PersonEntityRelation> {
      return localVarFp
        .updatePersonEntityRelation(personId, relationId, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Posting
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updatePosting(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Posting> {
      return localVarFp
        .updatePosting(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update ServiceType
     * @param {string} id
     * @param {UpdateServiceTypeRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateServiceType(
      id: string,
      body?: UpdateServiceTypeRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<ServiceType> {
      return localVarFp
        .updateServiceType(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Update Ticket
     * @param {string} id
     * @param {Session} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateTicket(
      id: string,
      body?: Session,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Ticket> {
      return localVarFp
        .updateTicket(id, body, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Finish PropertyManagement Registration
     * @param {VerifyPropertyManagementRegistrationRequest} [body]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    verify(
      body?: VerifyPropertyManagementRegistrationRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<PropertyManagement> {
      return localVarFp
        .verify(body, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
  /**
   *
   * @summary Delete PropertyManagement
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public _delete(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      ._delete(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Accept Invitation
   * @param {AcceptInvitationRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public acceptInvitation(
    body?: AcceptInvitationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .acceptInvitation(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Begin Password Reset
   * @param {BeginPasswordResetRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public beginPasswordReset(
    body?: BeginPasswordResetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .beginPasswordReset(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create PropertyManagement
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public create(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .create(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Account
   * @param {CreateAccountRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createAccount(
    body?: CreateAccountRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createAccount(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Asset
   * @param {Create} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createAsset(body?: Create, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createAsset(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Attachment of Communication
   * @param {string} id
   * @param {string} type
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createAttachment(
    id: string,
    type: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createAttachment(id, type, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Attachment of Document
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createAttachment1(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createAttachment1(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Add document category
   * @param {CreateDocumentCategoryRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createCategory(
    body?: CreateDocumentCategoryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createCategory(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Add Message to Communication
   * @param {string} type
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createCommunicationMessage(
    type: string,
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createCommunicationMessage(type, id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Conversations
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createConversations(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createConversations(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Document
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createDocument(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createDocument(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Estate
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createEstate(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createEstate(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get LivingUnits of Estate
   * @param {string} estateId
   * @param {CreateLivingUnitRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createLivingUnit(
    estateId: string,
    body?: CreateLivingUnitRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createLivingUnit(estateId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Person
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPerson(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createPerson(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Add Relation from Person to Estate or LivingUnit
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPersonEntityRelation(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createPersonEntityRelation(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Posting
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createPosting(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createPosting(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create ServiceType
   * @param {UpdateServiceTypeRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createServiceType(
    body?: UpdateServiceTypeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createServiceType(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Session
   * @param {EmailAddressAndPassword} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createSession(
    body?: EmailAddressAndPassword,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .createSession(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Ticket
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public createTicket(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .createTicket(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Account
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteAccount(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteAccount(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Asset
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteAsset(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteAsset(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Attachment of Communication
   * @param {string} communicationId
   * @param {string} type
   * @param {number} attachmentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteAttachment(
    communicationId: string,
    type: string,
    attachmentId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteAttachment(communicationId, type, attachmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Attachment of Document
   * @param {string} documentId
   * @param {number} attachmentId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteAttachment1(
    documentId: string,
    attachmentId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteAttachment1(documentId, attachmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete document category
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteCategory(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteCategory(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Conversation
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteConversation(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteConversation(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Document
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteDocument(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteDocument(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Estate and its LivingUnits
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteEstate(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteEstate(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Estate image
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteEstateImage(estateId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteEstateImage(estateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete LivingUnit of Estate
   * @param {string} estateId
   * @param {number} livingUnitId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteLivingUnit(
    estateId: string,
    livingUnitId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteLivingUnit(estateId, livingUnitId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete PropertyManagement Logo
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteLogo(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteLogo(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Message of Communication
   * @param {string} type
   * @param {string} communicationId
   * @param {number} messageId
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteMessage(
    type: string,
    communicationId: string,
    messageId: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deleteMessage(type, communicationId, messageId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Person
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePerson(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deletePerson(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Relation between Person and Estate and/or LivingUnit
   * @param {string} personId
   * @param {number} relationId
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePersonEntityRelation(
    personId: string,
    relationId: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .deletePersonEntityRelation(personId, relationId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Posting
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deletePosting(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deletePosting(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete ServiceType
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteServiceType(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteServiceType(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Delete Ticket
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public deleteTicket(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .deleteTicket(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Destroy Session
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public destroySession(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .destroySession(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Destroy Session
   * @param {string} token
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public destroySession1(
    token: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .destroySession1(token, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find Persons
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Persons being PropertyManager or related to Estates of the that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public find(
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .find(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find PropertyManagements
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public find1(
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .find1(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find Accounts
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public findAccounts(
    sort?: string,
    range?: string,
    filter?: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .findAccounts(sort, range, filter, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find PropertyManagements and aggregate for admin overview
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {boolean} [loadContacts]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only PropertyManagements with that id will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public findAndAggregate(
    sort: string,
    range: string,
    filter?: string,
    loadContacts?: boolean,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .findAndAggregate(
        sort,
        range,
        filter,
        loadContacts,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find Conversations
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public findConversations(
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .findConversations(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find Documents
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] if set, only Documents of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public findDocuments(
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .findDocuments(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find Postings
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public findPostings(
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .findPostings(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find Tickets
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public findTickets(
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .findTickets(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Verify Password Reset
   * @param {FinishPasswordResetRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public finishPassworReset(
    body?: FinishPasswordResetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .finishPassworReset(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get PropertyManagement
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public get(id: string, body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .get(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Account
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAccount(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAccount(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAccountLevels(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAccountLevels(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAdvPdf(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAdvPdf(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get agb.pdf content
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAgbPdfContent(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAgbPdfContent(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get agb.pdf info
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAgbPdfInfo(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAgbPdfInfo(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all document categories
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAllCategories(options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAllCategories(options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Find ServiceTypes
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAllServiceTypes(
    sort?: string,
    range?: string,
    filter?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAllServiceTypes(sort, range, filter, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAssetContent(
    id: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAssetContent(id, extension, preview, scalePercent, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Asset Info
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAssetInfo(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getAssetInfo(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get assignable property managers and ticket managers of the estate
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAssignablePropertyManagersOfEstate(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAssignablePropertyManagersOfEstate(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get assignable property managers and ticket managers of the estate. This is a lighter version of the /propertymanagers endpoint: It is less restrictive but does not include the managers\' full names.
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAssigneeInitials(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAssigneeInitials(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} type
   * @param {string} communicationId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {string} [sig]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAttachmentContent(
    type: string,
    communicationId: string,
    attachmentId: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    sig?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAttachmentContent(
        type,
        communicationId,
        attachmentId,
        extension,
        preview,
        scalePercent,
        sig,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Attachment Content (Image, PDF or Text)
   * @param {string} documentId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {string} [sig]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAttachmentContent1(
    documentId: string,
    attachmentId: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    sig?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAttachmentContent1(
        documentId,
        attachmentId,
        extension,
        preview,
        scalePercent,
        sig,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} id
   * @param {string} attachmentId
   * @param {string} extension
   * @param {boolean} [preview]
   * @param {number} [scalePercent]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAttachmentContent2(
    id: string,
    attachmentId: string,
    extension: string,
    preview?: boolean,
    scalePercent?: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAttachmentContent2(
        id,
        attachmentId,
        extension,
        preview,
        scalePercent,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} type
   * @param {string} communicationId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAttachmentContentSignature(
    type: string,
    communicationId: string,
    attachmentId: string,
    extension: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAttachmentContentSignature(
        type,
        communicationId,
        attachmentId,
        extension,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Signature for Attachment Content URL (Image, PDF or Text)
   * @param {string} documentId
   * @param {string} attachmentId
   * @param {string} extension
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getAttachmentContentSignature1(
    documentId: string,
    attachmentId: string,
    extension: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getAttachmentContentSignature1(
        documentId,
        attachmentId,
        extension,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get document category
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getCategory(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getCategory(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Conversations
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getConversation(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getConversation(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Document
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getDocument(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getDocument(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Estate by id
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEstate(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEstate(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Contacts of Estate
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEstateContacts(estateId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getEstateContacts(estateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {string} estateId
   * @param {string} assetId
   * @param {string} extension
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEstateImageContent(
    estateId: string,
    assetId: string,
    extension: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEstateImageContent(estateId, assetId, extension, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Estate image info
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEstateImageInfo(estateId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getEstateImageInfo(estateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Search Estates
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getEstates(
    sort?: string,
    range?: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getEstates(sort, range, filter, xPROPERTYMANAGEMENTID, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get LivingUnit of Estate
   * @param {string} estateId
   * @param {number} livingUnitId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLivingUnit(
    estateId: string,
    livingUnitId: number,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getLivingUnit(estateId, livingUnitId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all LivingUnits of Estate
   * @param {string} estateId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getLivingUnits(estateId: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getLivingUnits(estateId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Messages of Communication
   * @param {string} type
   * @param {string} id
   * @param {string} [sort]
   * @param {string} [range]
   * @param {string} [filter]
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getMessages(
    type: string,
    id: string,
    sort?: string,
    range?: string,
    filter?: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getMessages(type, id, sort, range, filter, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Person
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPerson(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPerson(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Relations from Person to Estates or LivingUnits
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPersonEntityRelations(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getPersonEntityRelations(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Posting
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getPosting(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getPosting(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get ServiceType
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getServiceType(id: string, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .getServiceType(id, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Session
   * @param {string} token
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getSession(
    token: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getSession(token, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get Ticket
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTicket(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getTicket(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Ticket Board overview data
   * @param {string} sort
   * @param {string} range
   * @param {string} [filter]
   * @param {number} [xPROPERTYMANAGEMENTID] If set, only Communications of Estates of that PropertyManagement will be returned
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public getTicketOverview(
    sort: string,
    range: string,
    filter?: string,
    xPROPERTYMANAGEMENTID?: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .getTicketOverview(
        sort,
        range,
        filter,
        xPROPERTYMANAGEMENTID,
        body,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {number} [xPROPERTYMANAGEMENTID]
   * @param {File} [uploadFile]
   * @param {string} [type]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public importXls(
    xPROPERTYMANAGEMENTID?: number,
    uploadFile?: File,
    type?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .importXls(xPROPERTYMANAGEMENTID, uploadFile, type, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Invite Person
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public invitePerson(body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .invitePerson(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   * If the email address is already in use by an account, a login reminder email will be sent and a 409 will be returned. If the email address is already taken by a person invitation a 409 will be returned. If the email address is already taken by a PropertyManagementRegistration (not a PropertyManagement), the registration will be overwritten and a 200 will be returned.
   * @summary Begin PropertyManagement Registration
   * @param {RegisterPropertyManagementRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public register(
    body?: RegisterPropertyManagementRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .register(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update PropertyManagement
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public update(id: string, body?: Session, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .update(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Account
   * @param {string} id
   * @param {UpdateAccountRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateAccount(
    id: string,
    body?: UpdateAccountRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateAccount(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Account Password
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateAccountPassword(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateAccountPassword(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update AGB PDF
   * @param {Create} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateAgbPdf(body?: Create, options?: RawAxiosRequestConfig) {
    return DefaultApiFp(this.configuration)
      .updateAgbPdf(body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Updates assigned estates a of Account
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateAssignedEstates(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateAssignedEstates(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Create Attachment of Communication
   * @param {string} id
   * @param {string} type
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateAttachments(
    id: string,
    type: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateAttachments(id, type, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Attachments of Document
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateAttachments1(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateAttachments1(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update document category
   * @param {string} id
   * @param {UpdateDocumentCategoryRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateCategory(
    id: string,
    body?: UpdateDocumentCategoryRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateCategory(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Conversations
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateConversations(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateConversations(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Document
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateDocument(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateDocument(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Estate
   * @param {string} id
   * @param {UpdateEstateRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateEstate(
    id: string,
    body?: UpdateEstateRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateEstate(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Estate image
   * @param {string} estateId
   * @param {UpdateEstateImageRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateEstateImage(
    estateId: string,
    body?: UpdateEstateImageRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateEstateImage(estateId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update LivingUnit of Estate
   * @param {string} estateId
   * @param {number} livingUnitId
   * @param {UpdateLivingUnitRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateLivingUnit(
    estateId: string,
    livingUnitId: number,
    body?: UpdateLivingUnitRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateLivingUnit(estateId, livingUnitId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update PropertyManagement Logo
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateLogo(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateLogo(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update NotificationSettings of Account
   * @param {string} id
   * @param {NotificationSettings} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateNotificationSettings(
    id: string,
    body?: NotificationSettings,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateNotificationSettings(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update all Relations from Person to Estate or LivingUnit
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updatePersionEntityRelations(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updatePersionEntityRelations(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Person
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updatePerson(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updatePerson(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Relation of Person to Estate or LivingUnit
   * @param {string} personId
   * @param {number} relationId
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updatePersonEntityRelation(
    personId: string,
    relationId: number,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updatePersonEntityRelation(personId, relationId, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Posting
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updatePosting(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updatePosting(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update ServiceType
   * @param {string} id
   * @param {UpdateServiceTypeRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateServiceType(
    id: string,
    body?: UpdateServiceTypeRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateServiceType(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Update Ticket
   * @param {string} id
   * @param {Session} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public updateTicket(
    id: string,
    body?: Session,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .updateTicket(id, body, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Finish PropertyManagement Registration
   * @param {VerifyPropertyManagementRegistrationRequest} [body]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DefaultApi
   */
  public verify(
    body?: VerifyPropertyManagementRegistrationRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return DefaultApiFp(this.configuration)
      .verify(body, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
